import React, {Fragment, memo, useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import API from "../../app/api";
import Api from "../../app/api";
import _ from "lodash";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import {
  demographicPatient,
  mergeQueuePatient,
  setDemographicPatient,
  setLoading as setLoadingGlobal, setMergeQueuePatient,
} from '../../store/reducers/patient';
import PatientInfo from "../../components/header/patientInfo";
import config from "../../app/config";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {agylePref, saveAgylePreference} from "../../store/reducers/preferences";
import DemographicDetails from "./demographicDetails";
import AdmissionDetails from "./admissionDetails";
import Summary from "./summary";
import {Autocomplete, CircularProgress, FormLabel, StepButton, TextField, Tooltip} from "@mui/material";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import Grid from "@mui/material/Grid";
import {currentMap, mapHospitalList, updateMap} from '../../store/reducers/ward';
import {setSnackbar} from "../../store/reducers/globals";
import AgyleButton from "../../components/ui/buttons/agyleButton";
import SearchIcon from "@mui/icons-material/Search";
import FiledWithHistory from "../../controls/agyle/filedWithHistory";
import SearchHint from "../../components/header/searchHint";
import AgyleHeader from "../../components/header/agyleHeader/agyleHeader";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Typography from "@mui/material/Typography";
import useDict from "../../hooks/useDict";
import useOpenState from "../../hooks/useOpenState";
import AgyleBlockSwitch from "../../components/ui/switch/agyleBlockSwitch";
import {DEFAULT_STATE} from "../ward/forms/csm/bedRequestForm";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import clsx from "clsx";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import BedBookingAdmit from "./bedBookingAdmit";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import {hasOneOfPermission, hasPermission, Permissions, sendUserAudit, user} from "../../store/reducers/user";
import MessageBox from "../../util/messageBox";
import Formatter from "../../util/formatter";
import Notes from "../../util/notes";
import {addNotesForPatient} from "../../store/reducers/notes";
import PriorityListModal from "../../components/table/priorityListModal";
import PatientMerges from "../admin/patient_merges";
import AgyleDialog from "../../components/modal/agyleDialog";
import {CopyIcon} from "../../components/icons/adminIcons";
import {AgyleNamedIcon} from "../../components/icons/agyle";
import AgyleDatePicker from "../../components/ui/fields/agyleDatePicker";
import APIForm from "../../app/apiForm";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditTemporaryPatientModal from './editTemporaryPatientModal';
import Chip from '@mui/material/Chip';
import InformationBox from '../../components/other/informationBox';
import {attendanceCategory, getEcdsVersion} from '../../store/reducers/dicts';
import AgyleSelectField from '../../components/ui/selector/agyleSelectField';
import Box from '@mui/material/Box';
import BedasList from '../ward/bedasList';
import {isCentralPageModuleEnabled} from '../centralPage/helper';
import {registrationConfig} from '../../store/reducers/externalConfig';
import { AUDIT_TYPES } from '../../util/auditUtil';

const useStyles = makeStyles((theme) => ({
  groupRoot: {
    marginBottom: 10,
    padding: 5,
    borderRadius: 5,
  },
  background: {
    backgroundColor: theme.palette.background.default,
  },
  dialogTitle: {
    textAlign: "center",
    padding: "10px",
  },
  dialogContent: {
    width: "100%",
  },
  stickyHeader: {
    position: "sticky",
    backgroundColor: theme.palette.background.default,
    top: 0,
  },
  body: {
    width: "90%",
    margin: "30px 5% 5% 5%",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    // paddingLeft: 20
    fontSize: 18,
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    //backgroundColor: theme.palette.background.paper,
    "&:hover": {
      // backgroundColor: theme.palette.background.,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
  },

  searchInput: {
    padding: "20px 0 20px 0",
    position: 'relative',
    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    //height: '100%',
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
    zIndex: 2
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  searchButtons: {
    textAlign: "center",
    borderBottom: "1px solid #434343",
    paddingBottom: "10px",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.default.main,
    },
  },
  activeAttendance: {
    backgroundColor: theme.palette.default.main,
    "&:hover": {
      backgroundColor: theme.palette.default.light,
    }
  },
  bedasAttendance: {
    backgroundColor: theme.palette.acuityColors.color4.background,
    "&:hover": {
      backgroundColor: theme.palette.acuityColors.color4.background,
    }
  },
  isDeceased: {
    background: 'repeating-linear-gradient(45deg, #8F8F8F 0, #8F8F8F 15px, #3C4042 15px, #3C4042 30px)',
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
  userLog: {
    fontSize: 11,
    fontStyle: "italic",
    color: theme.palette.mode === "light" ? "#4B4B4B" : "#818181",
  },
  comment: {
    fontSize: 15,
    padding: 5,
    backgroundColor: theme.palette.background.default,
    borderRadius: 5,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 10,
    flexWrap: 'wrap',
    width: "100%",
    marginBottom: "15px",
    paddingTop: "12px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  headerDemographics: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#404040",
    maxWidth: "max-content",
    flexBasis: "content",
    borderRadius: "10px",
    padding: "0.5rem 1rem",
    marginRight: "1rem",
    paddingRight: 0,
  },
  previousAttendancesContainer: {
    display: "flex",
    gap: 20,
    alignItems: "center",
    flexWrap: 'nowrap'
  },
  divRow: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
}));

const getInitialAdmission = (externalConfig) => ({
  admitDate: moment(),
  attendanceSource: null,
  ambulanceIncidentNumber: "",
  conveyingAmbulanceOrgId: "",
  careContactIdentifier: '',
  arrivalDateTime: null,
  attendanceType: null,
  chiefComplaint: null,
  historyOfPresentingComplaint: "",
  department: null,
  location: null,
  modeOfArrival: null,
  placeOfInjury: null,
  majorTraumaFlag: false,
  flag111: false,
  flag111Timestamp: null,
  lastAttendanceId: "",
  attendanceCategory: null,
  escortArray: [],
  cpIs: false,
  cpIsAlertPresent: false,
  assaultRelated: false,
  feedback: externalConfig?.feedback || false,
});

export const isChild = (patientAge) => {
  return patientAge < 18;
};

export const admitBase = () => {
  return {
    patientUpdate: false,
    patientUnknown: false,
    addressLines: "",
    street: "",
    city: "",
    postTown: "",
    county: "",
    // cpIs: false,
    // cpIsAlertPresent: false,
    dob: null,
    ethnicGroup: null,
    familyName: "",
    firstName: "",
    gender: null,
    hospitalNumber: "",
    middleNames: "",
    nhsNumber: "",
    ehicCard: null,
    ehicNumber: "",
    noEhicReason: "",
    occupation: "",
    overseasStatus: null,
    postalCode: "",
    schoolAddress: "",
    schoolName: "",
    schoolPostalCode: "",
    schoolContact: "",
    spokenLanguage: null,
    spokenLanguageExists: false,
    interpreterLanguage: null,
    accommodationStatus: null,
    patientNeedsInterpreter: false,
    attendanceCategory: null,
    speedRegistry: false,
    escortArray: [],
    household: null,
    nokList: [],
    employerName: '',
    employerPostalCode: '',
    employerAddress: '',
    phoneNumbers: [],
    emailAdresses: [],
    gp: null,
    surgery: null,
    nhsBlockedProceeding: false
  };
};

const ChooseRegistrationStep = memo((props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  // Temp pt merge
  const patientToMerge = useSelector(mergeQueuePatient);
  const isSamePatientToMerge = patientToMerge?.patient?.__id === props.patient.current?.__id;
  const [optional, setOptional] = useState(false);

  const isPatient = props.patient.current !== null;
  const isBedas = props.patient.current?.tags && props.patient.current?.tags.includes("bedas");
  const haveActiveAtt = props.patient.current?.activeAttendances
      ? !_.isEmpty(_.filter(props.patient.current?.activeAttendances, pt => pt?.attendanceType === "E" && _.isNil(pt?.endDate)))
      : false;
  const isDeceased = props.patient?.current && (props.patient?.current?.tags?.includes("deceased") || !_.isNull(props.patient?.current?.dod));
  const isTemporary = props.patient?.current?.tags?.includes("temporary") && haveActiveAtt;
  const ptLocation = haveActiveAtt ? _.find(props.patientsFacilities, {id: props.patient?.current?.__id}) : null;
  const checkHospital = config?.modules?.map?.customMap ? _.isNull(props.hospital) : false;
  let wrongLocation = false;
  if (ptLocation) {
    wrongLocation = ptLocation?.location !== props.hospital?.hospitalId;
  }

  const handleMergeTemporary = (removeBedas) => {
    props.mergeTemporary(isSamePatientToMerge, removeBedas);
  };

  const disableMergeButton = () => {
    let activeAtt = false;
    if (patientToMerge && !isSamePatientToMerge) {
      activeAtt = haveActiveAtt
    }
    return activeAtt || checkHospital;
  };

  return (
    <>
      <DialogTitle className={clsx(classes.background, classes.dialogTitle)}>
        <Typography variant="h6" component="div">
          {t('Choose Registration')}
        </Typography>
      </DialogTitle>
      <DialogContent
        className={clsx(classes.background, classes.dialogContent, "scroll-normal-white")}
      >
        <Grid container spacing={2} justifyContent="space-between">
          {checkHospital &&
            <Grid item xs={12}>
              <InformationBox type="warning">
                {t("Please choose a hospital.")}
              </InformationBox>
            </Grid>
          }

          {wrongLocation &&
              <Grid item xs={12}>
                <InformationBox type="warning">
                  {t('Patients have an open attendance at another hospital site.')}
                </InformationBox>
              </Grid>
          }

          {!isDeceased &&
            <Grid item xs={config?.admitPatient?.bedBooking ? 6 : 12}>
              <AgyleButton
                onClick={props.onCreateNewPatient}
                color="primary"
                variant="contained"
                width={"100%"}
                disabled={checkHospital || isTemporary || (patientToMerge && !optional) || wrongLocation}
              >
                {t(isPatient ? `${haveActiveAtt ? "Update" : "Create"} Attendance` : "Create New Patient / Not in Database")}
              </AgyleButton>
            </Grid>
          }

          {isDeceased &&
            <Grid item xs={config?.admitPatient?.bedBooking ? 6 : 12}>
              <AgyleButton
                onClick={props.onUpdateDemographic}
                color="primary"
                variant="contained"
                width={"100%"}
                disabled={checkHospital || wrongLocation}
              >
                {t("Update Patient Demographic")}
              </AgyleButton>
            </Grid>
          }

          {config?.admitPatient?.bedBooking && (
            <Grid item xs={6}>
              <AgyleButton
                onClick={props.onAddBedBooking}
                color="primary"
                variant="contained"
                width={"100%"}
                disabled={haveActiveAtt || checkHospital || isDeceased || (patientToMerge && !optional) || wrongLocation}
              >
                {t("Add To Bed Booking")}
              </AgyleButton>
            </Grid>
          )}

          {(props.patient?.current && config?.admitPatient?.reAttendanceEnabled) && (
            <Grid item xs={6}>
              <AgyleButton
                onClick={props.onReAttendance}
                color="primary"
                variant="contained"
                width={"100%"}
                disabled={haveActiveAtt || checkHospital || isDeceased  || (patientToMerge && !optional) || wrongLocation}
              >
                {t("Re Attendance")}
              </AgyleButton>
            </Grid>
          )}

          {(isPatient && config?.modules?.bedas?.enabled && isBedas) && (
            <Grid item xs={6}>
              <AgyleButton
                onClick={props.onBedas}
                color="primary"
                variant="contained"
                width={"100%"}
                disabled={haveActiveAtt || checkHospital || isDeceased  || (patientToMerge && !optional) || wrongLocation}
              >
                {t("Follow Up")}
              </AgyleButton>
            </Grid>
          )}

          {(isPatient && !patientToMerge) &&
            <Grid item xs={6}>
              <AgyleButton
                  onClick={props.mergInTo}
                  color="primary"
                  variant="contained"
                  width={"100%"}
                  disabled={checkHospital || wrongLocation}
              >
                {t("Merge with temporary patient")}
              </AgyleButton>
            </Grid>
          }

          {(isPatient && patientToMerge) &&
            <Grid item xs={6}>
              <AgyleButton
                  onClick={handleMergeTemporary.bind(this, false)}
                  color="primary"
                  variant="contained"
                  width={"100%"}
                  disabled={disableMergeButton() || wrongLocation}
              >
                {t(`${isSamePatientToMerge ? "Create New Patient / Not in Database" : "Merge with selected temp. patient"}${isBedas ? ' (BEDAS Attendance)' : ''}`)}
              </AgyleButton>
            </Grid>
          }

          {(isPatient && patientToMerge && isBedas && !isSamePatientToMerge) &&
            <Grid item xs={6}>
              <AgyleButton
                  onClick={handleMergeTemporary.bind(this, true)}
                  color="primary"
                  variant="contained"
                  width={"100%"}
                  disabled={disableMergeButton() || wrongLocation}
              >
                {t('Merge with selected temp. patient. (New Attendance)')}
              </AgyleButton>
            </Grid>
          }
        </Grid>
      </DialogContent>

      <DialogActions
        className={clsx(classes.background, classes.dialogActions)}
      >
        {(patientToMerge && !wrongLocation) &&
          <div className={classes.divRow} style={{marginRight: 'auto'}}>
            <AgyleBlockSwitch
                onChange={setOptional}
                value={optional}
            />

            <FormLabel style={{marginLeft: 5}}>
              {t("Show optional")}
            </FormLabel>
          </div>
        }

        <AgyleButton
          onClick={() => {
            props.patient.current = null;
            props.onClose();
          }}
          color="primary"
        >
          Close
        </AgyleButton>
      </DialogActions>
    </>
  );
});

const AgyleButtonSection = ({
  activeStep,
  setActiveStep,
  steps,
  admit,
  admission,
  checkFields,
  patientIsSelected,
  setClearForm,
  updatePatient,
  cancelPatientUpdate,
  savePatientUpdate,
  backToInitialAdmit,
  isPatientUpdated,
  handleSubmitAdmission,
  patientOnWhiteboard,
  openCreatePatientDialog,
  isBedBookingChosen,
  setSpeedRegFlag,
  fastReg,
  createNewPatient,
  handleConfirmDemographics,
  openTemporaryPatientEdit,
  openBedas,
  openPriorityList,
  openPatientMerge,
  hospital,
  temporaryPatientRef,
  temporaryPatientAttendanceRef,
  isAddOnlyPatient,
  onlyDemographic,
  validPostCode,
  validTemporaryPostCode
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation();

  const ptFormPriority = useSelector(demographicPatient);

  const haveFastFlag  = admit?.tags?.includes("fastRegistry")

  const genderIsValid = () => !admit.gender || (admit.gender?.__description !== 'Male' && admit.gender?.__description !== "Female");

  const isTempEdit = () => temporaryPatientRef && temporaryPatientRef?.current !== null && !genderIsValid();
  const checkHospital = config?.modules?.map?.customMap ? _.isNull(hospital) : false;

  const renderSearchButtons = () => {
    return (
      <div
        className={classes.buttonsContainer}
        style={{ flexGrow: 1 }}
      >
        {(config?.admitPatient?.bedasListEnabled && config?.modules?.bedas?.enabled) &&
            <AgyleButton
                onClick={openBedas}
                style={{ marginLeft: "10px", minWidth: 105 }}
                disabled={checkHospital}
            >
              {t("Follow Up List")}
            </AgyleButton>
        }

        {config?.admitPatient?.enablePatientMerge &&
          <AgyleButton
            onClick={openPatientMerge}
            style={{ marginLeft: "10px", minWidth: 120 }}
            disabled={checkHospital || !dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_MERGES_PAGE, Permissions.CAN_ACCESS_ADMIN_PAGE]))}
          >
            {t("Patient Merge")}
          </AgyleButton>
        }

        {config?.admitPatient?.enablePriorityList &&
          <AgyleButton
            onClick={openPriorityList}
            style={{ marginLeft: "10px", minWidth: 105 }}
            disabled={checkHospital || !dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_PRIORTY_LIST))}
          >
            {t("Priority List")}
          </AgyleButton>
        }

        {/*{config?.admitPatient?.enableTemporaryPatientEdit &&*/}
        {/*    <AgyleButton*/}
        {/*        onClick={openTemporaryPatientEdit}*/}
        {/*        style={{ marginLeft: "10px" }}*/}
        {/*        variant="contained"*/}
        {/*        disabled={fastReg}*/}
        {/*    >*/}
        {/*      {t("EDIT TEMPORARY PATIENT")}*/}
        {/*    </AgyleButton>*/}
        {/*}*/}

        <AgyleButton
          onClick={setSpeedRegFlag}
          variant="contained"
          disabled={checkHospital || fastReg}
          style={{ marginLeft: "10px", minWidth: 208 }}
        >
          {t("+ ADD TEMPORARY PATIENT")}
        </AgyleButton>

        {config?.admitPatient?.patientCreationEnabled && <AgyleButton
            onClick={() => {
              createNewPatient(true);
              dispatch(setMergeQueuePatient(null));
            }}
            variant="contained"
            disabled={checkHospital}
            style={{ marginLeft: "10px", minWidth: 163 }}
        >
          {t("+ ADD NEW PATIENT")}
        </AgyleButton>}

        <AgyleButton
          onClick={() => {
            fastReg ? createNewPatient() : openCreatePatientDialog();
          }}
          variant="contained"
          disabled={checkHospital}
          style={{ marginLeft: "10px", minWidth: 194 }}
        >
          {t("+ ADD NEW ATTENDANCE")}
        </AgyleButton>
      </div>
    );
  };

  const isSaveDisabled = () => {
    if (isPatientUpdated) {
      let invalidTemp = false;
      if (!_.isNil(admit?.postalCodeTemporary)) {
        invalidTemp = !validTemporaryPostCode || !admit?.streetTemporary;
      }
      return !validPostCode || invalidTemp;
    }
    return false;
  };

  const renderDemographicButtons = () => (
      <div className={classes.buttonsContainer} style={{flexGrow: 1}}>
        {(patientIsSelected && dispatch(hasPermission(Permissions.AGYLE_CAN_CONFIRM_DEMOGRAPHICS)) && haveFastFlag) &&
          <AgyleButton
              onClick={handleConfirmDemographics}
              variant="contained"
          >
            {t("Confirm Demographics")}
          </AgyleButton>
      }
      {patientIsSelected && (
        <>
          {isPatientUpdated && (
            <>
              <AgyleButton onClick={backToInitialAdmit} variant="outlined">
                {t("Back to Original Patient Data")}
              </AgyleButton>
              <AgyleButton onClick={cancelPatientUpdate} variant="outlined">
                {t("Cancel Patient Update")}
              </AgyleButton>
            </>
          )}
          <AgyleButton
            onClick={() => {
              if (isPatientUpdated) {
                savePatientUpdate();
              } else {
                updatePatient();
              }
            }}
            variant="contained"
            disabled={isSaveDisabled()}
          >
            {t(isPatientUpdated ? "Save" : "Update Patient Data")}
          </AgyleButton>
        </>
      )}

      {!patientIsSelected && (
        <AgyleButton onClick={() => setClearForm(true)} variant="contained">
          {t("Clear Form")}
        </AgyleButton>
      )}

      {!onlyDemographic &&
        <AgyleButton
          variant="contained"
          onClick={() => setActiveStep(prevState => prevState + 1)}
          disabled={!checkFields()}
        >
          {t(isBedBookingChosen ? "Bed Booking" : isAddOnlyPatient ? "Summary" : "Attendance Details")}
        </AgyleButton>
      }
    </div>
  );

  const checkAdmission = () => {
    const isArrivedByAmbulance = admission.modeOfArrival && (admission.modeOfArrival?.group === 'ambulance' || admission.modeOfArrival?.ambulance);
    const patientAge = moment().diff(moment(admit.dob), 'years');

    if (patientAge < 18 && !admission.cpIs) {
      return true
    }

      if (admission.flag111 && !admission.flag111Timestamp ||
          (isArrivedByAmbulance && (
              !admission.careContactIdentifier || !admission.conveyingAmbulanceOrgId || !admission.ambulanceIncidentNumber
          )) || !admission?.attendanceCategory || !admission.modeOfArrival) return true;

    return false;
  };

  const renderBedBookingButtons = () => (
    <div className={classes.buttonsContainer} style={{ flexBasis: "content" }}>
      <AgyleButton
        variant="contained"
        onClick={() => {
          setActiveStep((prevStep) => prevStep + 1);
        }}
        // disabled={checkBedBooking()}
      >
        {t("Summary")}
      </AgyleButton>
    </div>
  );

  const renderAdmissionButtons = () => (
    <div className={classes.buttonsContainer} style={{ flexBasis: "content" }}>
      <AgyleButton
        variant="contained"
        onClick={() => {
          setActiveStep((prevState) => prevState + 1);
        }}
        disabled={checkAdmission()}
      >
        {t("Proceed to Summary")}
      </AgyleButton>
    </div>
  );

  const renderSummaryButtons = () => (
    <div className={classes.buttonsContainer} style={{ flexBasis: "content" }}>
      <AgyleButton
        variant="contained"
        onClick={handleSubmitAdmission}
        disabled={isPatientUpdated}
      >
        {patientOnWhiteboard
          ? t("Update Patient Data") :
            isBedBookingChosen ? t("Add to Bed Booking") :
                isAddOnlyPatient ? t("Create New Patient") :
                    t(`${temporaryPatientAttendanceRef.current ? "Update" : "Create New"} Attendance`)}
      </AgyleButton>
    </div>
  );

  const renderStepButtons = () => {
    // eslint-disable-next-line default-case
    switch (activeStep) {
      case 0:
        return renderSearchButtons();
      case 1:
        return renderDemographicButtons();
      case 2:
        if (isAddOnlyPatient) {
          return renderSummaryButtons();
        } else if (isBedBookingChosen) {
          return renderBedBookingButtons();
        } else {
          return renderAdmissionButtons();
        }
      case 3:
        return renderSummaryButtons();
    }
  };

  const handleBack = () => {
    const back = activeStep - 1;
    setActiveStep(back)
    if (ptFormPriority && back === 0) dispatch(setDemographicPatient(null));
  }

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      className={classes.searchButtons}
      sx={{ pl: 2, mt: -0.6, flexWrap: "nowrap" }}
      gap={2}
    >
      <Grid item style={{ marginTop: "-15px", display: "flex" }}>
        <Grid item style={{ flexBasis: 40 }}
              sx={{
                flexBasis: {
                  sx: activeStep === 0 && 0,
                }
              }}
        >
          {activeStep !== 0 && (
            <IconButton
              variant="contained"
              color="secondary"
              onClick={handleBack}
              sx={{ maxHeight: "40px", marginTop: "7px" }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
        </Grid>

        <Grid item sx={{ pl: 1, display: 'flex', flexDirection: 'column', flexBasis: 'max-content', minWidth: 'max-content' }}>
          <Typography
            variant="h6"
            component="div"
            className={classes.headerText}
            style={{ display: 'flex', flexWrap: 'nowrap', flexBasis: 'max-content' }}
          >
            {isAddOnlyPatient ? t("Create New Patient") : t("Create New Attendance")}
          </Typography>

          <Typography
            variant="body2"
            component="div"
            className={classes.headerText}
          >
            {t("Step")} {activeStep + 1} {t("of")} {steps.length}
          </Typography>
        </Grid>
      </Grid>

      {renderStepButtons()}
    </Grid>
  );
};

class RequestDataParser {
   static getFormattedDOB = (admitObj) => {
    return moment(admitObj.dob).format("YYYY-MM-DD");
  };

   static getAddressLines = (admitObj, isTemporaryAddress) => {
    let arr = ["", "", "", ""];

    if (isTemporaryAddress) {
      if (!admitObj?.streetTemporary && !admitObj?.cityTemporary && !admitObj?.postTownTemporary && !admitObj?.countyTemporary) {
        return null
      }

      arr[0] = admitObj?.streetTemporary;
      arr[1] = admitObj?.postTownTemporary;
      arr[2] = admitObj?.cityTemporary;
      arr[3] = admitObj?.countyTemporary;

      return arr;
    }

    if (!admitObj.street && !admitObj.city && !admitObj.postTown && !admitObj.county) {
      return null
    }

    if (admitObj.street) {
      arr[0] = admitObj.street
    }
    if (admitObj.city) {
      arr[2] = admitObj.city
    }
    if (admitObj.postTown) {
      arr[1] = admitObj.postTown
    }
    if (admitObj.county) {
      arr[3] = admitObj.county
    }

    return arr;
  };

   static getPhoneNumbers = (admitObj) => {
    let temp = [];

    if (!admitObj.phoneNumbers || _.isEmpty(admitObj.phoneNumbers) ) {
      return null;
    }

    admitObj.phoneNumbers.forEach((phone) => {
      temp.push({
        number: phone.number,
        numberType: phone.type,
      });
    });

    return temp;
  };

   static getEmails = (admitObj) => {
    let temp = [];

    if (!admitObj.emailAdresses || _.isEmpty(admitObj.emailAdresses) ) {
      return null;
    }

    admitObj.emailAdresses.forEach((email) => {
        temp.push({ emailAddress: email.emailAddress })
    }
    );
    return temp;
  };

   static mapEhicObject = (admitObj) => {
     let ehicObject;
     if (!admitObj?.patientNumbers) return null;
     ehicObject = admitObj?.patientNumbers.find((patientNumber) => patientNumber.type === "EhicNumber" || patientNumber.simpleType === 'EhicNumber');

     return ehicObject;
   }

  static mapHouseholdObject = (admitObj) => {
    let temp = [];
    if (!admitObj.household || _.isEmpty(admitObj.household)) {
      return null;
    } else {
      admitObj.household.forEach((household) => {
        let obj = {};
        obj = {
          ...obj,
          householdInformation: household.householdInformation,
          householdPeoples: [],
        };
        const householdPeoples = household.householdPeople;
        if (householdPeoples && householdPeoples.length > 0) {
          householdPeoples.forEach((people) => {
            const peopleObj = {
              parentalResponsibility: people.parentalResponsibility,
              name: people.name,
              age: people.age,
              relationship: people.relationship,
              contact: people.contact,
            };

            obj = {
              ...obj,
              householdPeoples: [...obj["householdPeoples"], peopleObj],
            };
          });
        }

        temp = [...temp, obj];
      });
    }
    return temp;
  };

   static mapEscortObject = (admitObj) => {
    let temp = [];
    if (!admitObj.escortArray || _.isEmpty(admitObj.escortArray)) {
      return null;
    } else {
      admitObj.escortArray.forEach((escort) => {
        const obj = {
          parentalResponsibility: escort.parentalResponsibility,
          attendedWithChild: escort.attendedWithChild,
          name: escort.name,
          age: escort.age,
          relationship: escort.relationship,
          contact: escort.contact,
        };

        temp = [...temp, obj];
      });
    }
    return temp;
  };

   static mapNextOfKinObject = (admitObj) => {
    let temp = [];

    if (!admitObj.nokList || admitObj.nokList.length === 0) {
      return null;
    }

    admitObj.nokList.forEach((nextOfKin) => {
      let obj = {
        firstName: nextOfKin.firstName,
        familyName: nextOfKin.lastName,
        relationship: {
          __id: nextOfKin.relationship.__id,
        },
        phoneNumber: nextOfKin.phoneNumber,
      };

      if (RequestDataParser.getAddressLines(nextOfKin)) {
        obj = {
          ...obj,
          address: {
            addressLines: RequestDataParser.getAddressLines(nextOfKin),
            postalCode: nextOfKin.postalCode,
          }
        }
      }

      temp = [...temp, obj];
    });

    return temp;
  };
   static mapSchoolObject = (admitObj) => {
     let objToReturn;

     if (!admitObj.schoolName && !admitObj.schoolContact && !admitObj.schoolAddress && !admitObj.schoolPostalCode) {
       return null;
     }

     objToReturn = {
       name: admitObj.schoolName,
       contact: admitObj.schoolContact,
       address: {
         addressLines: [admitObj.schoolAddress],
         postalCode: admitObj.schoolPostalCode,
       }
     }

     return objToReturn;
   }

   static getGpId = admitObj => {
     if (!admitObj.gp) {
       return null;
     }

     const gpId = admitObj.gp?.gpCode || admitObj.gp?.__id || admitObj.gp?.__href.split("/").pop();
     return ({
       "__id": gpId
     })
   }

   static getSurgeryId = admitObj => {
     if (!admitObj.surgery) {
       return null;
     }

     const surgeryId = admitObj?.surgery?.__id;
     return ({
          "__id": surgeryId
         })
   }
}

class SelectPatientParser {
  static getAddresses = (field, tempAddress) => {
    let street = tempAddress ? null : "";
    let city =  tempAddress ? null : "";
    let postTown =  tempAddress ? null : "";
    let county =  tempAddress ? null : "";

    if (!field) {
      return [
        street,
        city,
        postTown,
        county,
      ];
    }

    switch (field.length) {
      case 1:
        street = field[0];
        break;
      case 2:
        street = field[0];
        city = field[1];
        break;
      case 3:
        street = field[0];
        city = field[1];
        county = field[2];
        break;
      case 4:
        street = field[0];
        city = field[2];
        postTown = field[1];
        county = field[3];
        break;
      default:
        break;
    }

    return [
      street,
      city,
      postTown,
      county,
    ];
  };

  static getGPId = (patient) => {
    if (!patient.gp) return;
    return patient.gp;
  };

  static getSurgeryId = (patient) => {
    if (!patient.surgery) return;
    return patient.surgery;
  };

  static getHistoryOfPresentingComplaint = (patient) => {
    let presentingComplaint = '';
    if (patient?.clerking?.historicPresentingComplaint) presentingComplaint = patient?.clerking?.historicPresentingComplaint;
    else if (patient?.studies?.seeAndTreat?.historyOfPresentingComplaint) presentingComplaint = patient?.studies?.seeAndTreat?.historyOfPresentingComplaint;
    else if (patient?.triage?.historicPresentingComplaint) presentingComplaint = patient?.triage?.historicPresentingComplaint;
    else if (patient?.metadata?.historyOfPresentingComplaint) presentingComplaint = patient?.metadata?.historyOfPresentingComplaint;
    return presentingComplaint;
  };

  static getHospitalNumber = patient => {
    let validHospitalNumber = patient.hospitalNumber;
    if (!validHospitalNumber) {
      validHospitalNumber = patient.__id;
    }
    if (!validHospitalNumber) {
      validHospitalNumber = patient.__href.split("/").pop();
    }

    return validHospitalNumber;
  }

  static getNHSNumber = (patient) => {
      const number = patient?.patientNumbers
          ? patient?.patientNumbers.find(
              (number) => number.type === "NhsNumber" || number.type === 'NHS' || number.simpleType === "NhsNumber"
          )?.number
          : "";

      return number;
  };

  static getEhicNumber = (patient) => {
    const ehicNumber = patient?.patientNumbers.find(
      (number) => number.simpleType === "EhicNumber" || number.type === "EhicNumber"
    )?.number;

    return ehicNumber || "";
  }

  static getEmail = (patient) => {
    let emailList = [];
    if (_.isEmpty(patient.emails)) {
      return null;
    }

    patient?.emails.forEach((email) => {
      emailList.push({
        emailAddress: email.emailAddress,
        type: email?.emailType,
      })
    });

    return emailList;
  };

  static getPhoneNumbers = (patient) => {
    if (_.isEmpty(patient?.phoneNumbers)) {
      return null;
    }
    return patient?.phoneNumbers.map((phone) => {
      return {
        number: phone.number,
        type: phone?.numberType,
      };
    });
  };

  static getNextOfKins = (patient) => {
    let nokList = [];
    if (_.isEmpty(patient?.nextOfKins)) {
      return null;
    }
    patient?.nextOfKins.forEach((nok) => {
      let nokObj = {
        firstName: nok.firstName || "",
        lastName: nok.familyName || "",
        relationship: nok.relationship || null,
        phoneNumber: nok.phoneNumber || "",
        postalCode: "",
        street: "",
        city: "",
        postTown: "",
        county: "",
      };

      if (nok.address) {
        const [ street, city, postTown, county ] = SelectPatientParser.getAddresses(
            nok.address.addressLines
        );
        nokObj = {
          ...nokObj,
          postalCode: nok.address.postalCode || "",
          street,
          city,
          postTown,
          county,
        };
      }

      nokList.push(nokObj);
    });
    return nokList;
  };
}

function AdmitPatient({ hospitalObj, disableHeader = false }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const agylePreference = useSelector(agylePref);
  const newCurrentMap = useSelector(currentMap);
  const patientToMerge = useSelector(mergeQueuePatient);
  const hospitalList = useSelector(mapHospitalList);

  // user
  const userObject = useSelector(user);
  const tester = Formatter.formatUserFullName(userObject);

  const controller = new AbortController();
  const ptFormPriority = useSelector(demographicPatient);
  const [hospital, setHospital] = useState(null);
  const [wardAttendances, setWardAttendances] = useState(null);
  const attendanceCategoryDict = useSelector(attendanceCategory);
  const reqConfig = useSelector(registrationConfig);

  const [admit, setAdmit] = useState(() => admitBase());
  const [admitCopy, setAdmitCopy] = useState(null);
  const [admission, setAdmission] = useState(() => getInitialAdmission(reqConfig));
  const [bedBookingData, setBedBookingData] = useState({});
  const [bedBookingForm, setBedBookingForm] = useState(DEFAULT_STATE);
  const [clearForm, setClearForm] = useState(false);
  const [isPatientUpdated, setIsPatientUpdated] = useState(false);
  const [mergeToNewCreatedPatient, setMergeToNewCreatedPatient] = useState(false);
  const [bedasRemove, setBedasRemove] = useState(false);

  const [patientUnknown, setPatientUnknown] = useState(false);
  const [patientOnWhiteboard, setPatientOnWhiteboard] = useState(false);
  const [isPatientDataModified, setIsPatientDataModified] = useState(false);
  const [isShowPreviousAttendances, setIsShowPreviousAttendances] =
    useState(false);
  const [isBedBookingChosen, setIsBedBookingChosen] = useState(false);
  const [isAddOnlyPatient, setIsAddOnlyPatient] = useState(false);
  const [isReAttendance, setIsReAttendance] = useState(false);
  const [isBedas, setIsBedas] = useState(false);
  const [speedRegFlag, setSpeedRegFlag] = useState(false);
  const [fastRegFlag, setFastRegFlag] = useState(false);
  const [isTemporaryPatientEdit, setIsTemporaryPatientEdit] = useState(false);
  const [isConfirmDemographicsOpen, openConfirmDemographics, closeConfirmDemographics] = useOpenState(false, true);
  const [temporaryMergePt, setTemporaryMergePt] = useState(null);
  const [onlyDemographic, setOnlyDemographic] = useState(false);
  const [patientNumbers, setPatientNumbers] = useState(null);

  const [loading, setLoading] = useState(false);
  const [patients, setPatients] = useState(null);
  const [patientsData, setPatientsData] = useState([]);
  const [patientsFacilities, setPatientsFacilities] = useState([]);

  const [activeStep, setActiveStep] = useState(0);

  // Error modal
  const [isAttErrorDownloadOpen, openAttErrorDownload, closeAttErrorDownload] = useOpenState(false, true);
  const tempPt = useRef(null);

  const [page, setPage] = useState(1);
  const [sort, setSort] = useState({ type: "", direction: true });
  const admitSearch = agylePreference?.searchHistory?.admitSearch
    ? agylePreference?.searchHistory?.admitSearch
    : [];
  const [searchValue, setSearchValue] = useState("");
  const [openDetails, setOpenDetails] = useState(false);

  const version = dispatch(getEcdsVersion(null));
  const ecdsVersionFilter = encodeURIComponent(`ecdsVersion eq '${version}' and deactivated ne true`)
  const [ethnicOptions, isEthnicLoading] = useDict("EthnicGroups");
  const [languageOptions, isLanguageLoading] = useDict("Languages");
  const [genderOptions, isGenderLoading] = useDict("Genders");
  const [overseasOptions, isOverseasLoading] = useDict(
      "OverseasVisitorChargingCategory"
  );
  const [arrivalModeOptions, isArrivalModeOptionsLoading] = useDict('EcdsArrivalMode', 'sort1,sort2,sort3,sort4', ecdsVersionFilter);
  const [chiefComplaintOptions, isChiefComplaintOptionsLoading] = useDict('EcdsChiefOfComplaint', 'sort1,sort2,sort3,sort4', ecdsVersionFilter);
  const [attendanceSourceOptions, isAttendanceSourceOptionsLoading] = useDict('EcdsAttendanceSource', 'sort1,sort2,sort3,sort4', ecdsVersionFilter);
  const [attendanceTypeOptions, isAttendanceTypeOptionsLoading] =
      useDict("AdmissionMethods");
  const [locationOptions, isLocationOptionsLoading] =
      useDict("AttendanceTypes");
  const [attendanceCategoryOptions, isAttendanceCategoryOptionsLoading] = useDict("AttendanceCategory");
  const [conveyingAmbulanceOptions, conveyingAmbulanceLoading] = useDict("ConveyingAmbulances");

  // Form search
  const [formsData, setFormsData] = useState([]);
  const [completedFormSearch, setCompletedFormSearch] = useState(false);
  const [startDateForm, setStartDateForm] = useState(null);
  const [endDateForm, setEndDateForm] = useState(null);
  const [searchedForms, setSearchedForms] = useState(config?.modules?.formSearch?.formList || []);

  const [
    isGenderMandatoryDialogOpen,
    openGenderMandatoryDialog,
    closeGenderMandatoryDialog,
  ] = useOpenState(false, false);
  const [isHistoryListOpen, openHistoryList, closeHistoryList] = useOpenState(
      false,
      false
  );
  const [
    isCreatePatientDialogOpen,
    openCreatePatientDialog,
    closeCreatePatientDialog,
  ] = useOpenState(false, false);
  const [isAlarmOpen, openAlarmDialog, closeAlarmDialog] = useOpenState(
    false,
    false
  );
  const [isPriorityListOpen, openPriorityList, closePriorityList] = useOpenState(false, false);
  const [isPatientMergeOpen, openPatientMerge, closePatientMerge] = useOpenState(false, true);
  const [isTemporaryPatientEditOpen, openTemporaryPatientEdit, closeTemporaryPatientEdit] = useOpenState(false, true);

  // Bedas List
  const [isBedasOpen, openBedas, closeBedas] = useOpenState(false, true);
  const bedasCalendar = useRef(null);
  const canEditBedasSessions = config?.bedasSessionManagementEnabled && dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_BEDAS_CALENDAR));

  const [patientIsSelected, setPatientIsSelected] = useState(false);

  const patientRef = useRef(null);
  const continueAttendanceRef = useRef(null);
  const bedBookingFormRef = useRef(null);
  const temporaryPatientRef = useRef(null);
  const temporaryPatientAttendanceRef = useRef(null);
  const patientMergeRef = useRef(null);

  const [validPostCode, setValidPostCode] = useState(true);
  const [validTemporaryPostCode, setValidTemporaryPostCode] = useState(true);

  // Disable postal code validation
  const [toggleNFA, setToggleNFA] = useState(false);
  const [toggleNFATemporary, setToggleNFATemporary] = useState(false);

  useEffect(() => {
    setPatients([]);
    if (completedFormSearch) {
      const time = moment().set({'hour': 6, 'minute': 0});
      setStartDateForm(moment(time).subtract(1, "day"));
      setEndDateForm(time);
    }
  }, [completedFormSearch]);

  useEffect(() => {
    setAdmission(prevState => ({
      ...prevState,
      feedback: reqConfig?.feedback || false,
    }))
  }, [reqConfig]);

  // Check if patient is waiting to merge
  useEffect(() => {
    if (!_.isEmpty(patientToMerge)) {
      const textSearch = `${patientToMerge?.patient?.firstName} ${patientToMerge?.patient?.familyName} ${moment(patientToMerge?.patient?.dob).format(config.defaultDateFormat)}`;
      setSearchValue(textSearch);
      searchPatients(textSearch);
    }
  }, [patientToMerge]);

  useEffect(() => {
    const checkAttendance = async (pts) => {
      const arr = [];

      for (const pt of pts) {
        const att = _.filter(pt?.activeAttendances, pt => pt?.attendanceType === 'E' && _.isNil(pt?.endDate))?.[0];
        const patientAttendanceData = {
          attendanceId: att?.attendanceId,
          patientId: pt?.hospitalNumber || pt?.__id,
        };
        await API.getPatientAttendance(patientAttendanceData)
            .then(res => {
              if (!_.isEmpty(res)) {
                arr.push({
                  id: pt?.hospitalNumber || pt?.__id,
                  location: res?.[0]?.facility,
                });
              }
            });
      }
      return arr;
    };

    if (!_.isEmpty(patients)) {
      const pts = _.filter(patients, p => !_.isEmpty(_.filter(p?.activeAttendances, pt => pt?.attendanceType === 'E' && _.isNil(pt?.endDate))));
      checkAttendance(pts).then(res => {
        setPatientsFacilities(res);
      });
    }
  }, [patients]);

  const [options, setOptions] = useState({
    resourceUri: "/patients",
    text: null,
    page: page,
    pageSize: 100,
    options: {},
  });
  const ids = useRef([]);

  const patientAge = moment().diff(admit?.dob, "years");
  let activeSteps;

  const stepper = [
    { id: 1, label: "Patient Search", active: true },
    { id: 2, label: "Demographic Details", active: true },
    {
      id: 3,
      label: isBedBookingChosen ? "Bed Booking" : "Attendance Details",
      // active: isAddOnlyPatient ? false : !temporaryPatientRef.current && !temporaryPatientAttendanceRef.current,
      // active: isAddOnlyPatient ? false : true,
      active: !isAddOnlyPatient && !onlyDemographic,
    },
    { id: 4, label: "Summary", active: !onlyDemographic },
  ];

  activeSteps = stepper.filter((step) => step.active);

  const matchDot = (str) => {
    const objectKeys = str.split(".");
    return objectKeys;
  };

  const modifyValue = (value) => {
    if (value === null) {
      return null;
    }

    const { name, value: val } = value[0];
    let tempObject = {};

    if (name.includes(".")) {
      const objKeys = matchDot(name);
      for (let i = objKeys.length - 1; i >= 0; i--) {
        if (i === objKeys.length - 1) {
          tempObject[objKeys[i]] = val;
        } else {
          tempObject = {
            [objKeys[i]]: tempObject,
          };
        }
      }

      setBedBookingData((prevState) => ({
        ...prevState,
        ...tempObject,
      }));
    } else {
      tempObject[name] = val;

      setBedBookingData((prevState) => ({
        ...prevState,
        ...tempObject,
      }));
    }
  };

  const findGender = (code) => {
    if (_.isEmpty(genderOptions)) {
      return null;
    }

    return genderOptions.find((gender) => gender.__code === code);
  };

  useEffect(() => {
    if (config.modules?.map?.customMap) {
      setHospital(hospitalObj ? hospitalObj : newCurrentMap);
    }
  }, [newCurrentMap, hospitalObj]);

  useEffect(() => {
    return () => {
      controller.abort();
      dispatch(setDemographicPatient(null));
      dispatch(setMergeQueuePatient(null));
    };
  }, []);

    useEffect(() => {
      if (patientMergeRef.current && patientMergeRef.current.activeAttendances) {
        renderErrorSnackbar(`Only one active attendance possible. Please discharge the ${patientMergeRef.current.hospitalNumber} patient first.`)
      }
    }, [patientMergeRef.current]);

  // If pt is selected from priority list then
  useEffect(() => {
    if (ptFormPriority?.patient
        && (!isEthnicLoading && !isLanguageLoading && !isGenderLoading && !isGenderLoading && !isOverseasLoading && !isArrivalModeOptionsLoading && !isChiefComplaintOptionsLoading)) {
      selectPatient(ptFormPriority?.patient, ptFormPriority);
      closePriorityList();
    }
  }, [ptFormPriority, isEthnicLoading, isLanguageLoading, isGenderLoading, isGenderLoading, isOverseasLoading, isArrivalModeOptionsLoading, isChiefComplaintOptionsLoading]);

  useEffect(() => {
    if (activeStep === 0 && !ptFormPriority) {
      setAdmission(getInitialAdmission(reqConfig));
      setAdmit(admitBase());
      setBedBookingForm(DEFAULT_STATE);
      setAdmitCopy(null);
      setPatientIsSelected(false);
      setIsPatientUpdated(false);
      setSpeedRegFlag(false);
      setIsBedBookingChosen(false);
      patientRef.current = null;
      setIsTemporaryPatientEdit(false);
      temporaryPatientRef.current = null;
      temporaryPatientAttendanceRef.current = null;
      continueAttendanceRef.current = null;
      patientMergeRef.current = null;
      setIsAddOnlyPatient(false);
      setIsReAttendance(false);
      setIsBedas(false);
      setOnlyDemographic(false);
      setPatientNumbers(null);
      setMergeToNewCreatedPatient(false);
      setBedasRemove(false);
      setValidPostCode(true);
      setValidTemporaryPostCode(true);
      setToggleNFA(false);
      setToggleNFATemporary(false);
    };
    getWardsAttendances();
  }, [activeStep, ptFormPriority]);

  // useEffect(() => {
  //   if (patientAge >= 18) {
  //     setAdmit(prevState => ({
  //       ...prevState,
  //       cpIs: false,
  //       cpIsAlertPresent: false,
  //       schoolAddress: '',
  //       schoolName: '',
  //       schoolPostalCode: '',
  //       schoolContact: ""
  //     }))
  //   } else {
  //     setAdmit(prevState => ({
  //       ...prevState,
  //       employerName: "",
  //       employerAddress: "",
  //       employerPostalCode: "",
  //     }))
  //   }
  // }, [admit.dob])

  useEffect(() => {
    if (clearForm) {
      const defaultLanguage =
        languageOptions &&
        languageOptions.find((item) => item.__description === "English");

      const defaultOverseas =
        overseasOptions &&
        overseasOptions.find(
          (item) => item.__description === "Standard NHS -funded"
        );

      let baseAdmit = admitBase();

      const defaultOptions = {
        overseasStatus: defaultOverseas,
        spokenLanguage: defaultLanguage,
      };

      baseAdmit = { ...baseAdmit, ...defaultOptions };

      setAdmit(baseAdmit);
      setPatientIsSelected(false);
    }
    return () => setClearForm(false);
  }, [clearForm]);

  useEffect(() => {
    if (patientOnWhiteboard && !patientIsSelected) {
      setPatientOnWhiteboard(false);
    }
  }, [patientOnWhiteboard, patientIsSelected]);

  useEffect(() => {
    const timeout = setTimeout(
      () => (window._scrollBarRef._container.scrollTop = 0),
      1
    );

    return () => clearTimeout(timeout);
  }, [activeStep]);

  const continueAttendance = useCallback(
      (attendance) => {
        const chiefComplaint = attendance.triage?.chiefComplaint
            ? attendance.triage?.chiefComplaint
            : attendance?.admission?.clerking?.chiefComplaint
                ? attendance?.admission?.clerking?.chiefComplaint
                : null;
        const arrivalModeDescription =
            attendance?.admission?.arrivalModeDescription || null;
        // const attendanceSource =
        const location = attendance?.admission.attendanceType || "";
        const attendanceTypeDescription =
            attendance?.admission?.admissionTypeDescription || "";

        const admissionDataToPass = {
          chiefComplaint,
          arrivalModeDescription,
          location,
          attendanceTypeDescription,
        };

        continueAttendanceRef.current = admissionDataToPass;
        selectPatient(attendance.patient);
      },
      [continueAttendanceRef.current]
  );

  const cancelAttendance = useCallback((attendance) => {
  }, []);
  const cancelDischarge = useCallback((attendance) => {
  }, []);

  const renderSuccessSnackbar = (textMessage) => dispatch(
      setSnackbar({
        open: true,
        message: textMessage,
        type: "success",
      })
  );

  const renderInfoSnackbar = textMessage => dispatch(
        setSnackbar({
            open: true,
            message: textMessage,
            type: "info",
        })
  )

  const renderErrorSnackbar = textMessage => dispatch(
      setSnackbar({
        open: true,
        message: textMessage,
        type: "error",
      })
  );

  const renderNoPermissionSnackbar = () => dispatch(
    setSnackbar({
      open: true,
      message: t("You do not have permission to perform this operation."),
      type: "error",
    })
  );

  const updatePatient = () => {
    setIsPatientUpdated(true);
    if (!admitCopy) {
      let admitCopy = _.cloneDeep(admit);
      setAdmitCopy(admitCopy);
    }
  };

  const backToInitialAdmit = () => {
    setAdmit({ ...admitCopy, patientUpdate: false });
    setIsPatientUpdated(false);
    setIsPatientDataModified(false);
    setAdmitCopy(null);
  };

  const cancelPatientUpdate = () => {
    setIsPatientUpdated(false);
    setAdmit(admitCopy);
  };

  const savePatientUpdate = () => {
    if (!_.isEqual(admit, admitCopy)) {
      setIsPatientDataModified(true);
      handleUpdatePatient(admit);
    } else {
      setIsPatientUpdated(false);
    }
  };

  const handleHistoryChange = (hist) => {
    if (hist) {
      const obj = {
        searchHistory: {
          ...agylePreference.searchHistory,
          admitSearch: [...hist],
        },
      };
      dispatch(saveAgylePreference(obj));
    }
  };

  const handleSubmit = (value) => {
    if (value !== "") {
      searchPatients(value);
    }
  };

  const checkIfPatientOnWhiteboard = useCallback((selectedPatient) => {
    const haveActiveAtt = selectedPatient?.activeAttendances
                ? !_.isEmpty(_.filter(selectedPatient?.activeAttendances, pt => pt?.attendanceType === "E" && _.isNil(pt?.endDate)))
                : false;
    setPatientOnWhiteboard(haveActiveAtt);
  },[])

  useEffect(() => {
    if (options.text !== null) {
      setLoading(true);
      setPatients([]);

      API.getSearchList(options)
          .then((res) => {
            if (res.status === 200) {
              let pts = _.filter(res.data.collection['__data'], p => !_.isNull(p));

              if (!_.isEmpty(ids.current)) {
                pts = _.filter(pts, p => ids.current?.includes(p?.__id));
              }

              setPatients(pts);
              // setTotalCounter(res.data.collection['__size']);
              // setPagesCount(res.data.collection['__pageCount']);
              window._scrollBarRef.updateScroll();
            }
            if (res.status === 204) setPatients([]);
            if (res.status !== 200 && res.status !== 204) {
              console.debug("API.getPatientsList request status : " + res.status);
            }
          })
          .finally(() => {
            ids.current = [];
            setLoading(false);
          });
    }
  }, [options]);

  useEffect(() => {
    if (!_.isEmpty(patients)) {
      const ids = patients.map(pt => pt?.__id);
      API.getPatientsAdditionalData(ids).then(data => {
        setPatientsData(data);
      });
    } else {
      setPatientsData([]);
    }
  }, [patients]);

  useEffect(() => {
    const patientAge = moment().diff(admit.dob, "years");

    if (admit.gpHref && !admit.gp) {
      API.getGpDetails(admit.gpHref).then((res) => {
        if (res.status !== 200) {
          return renderInfoSnackbar("Please update GP details.");
        }

        setAdmit((pr) => ({
          ...pr,
          gp: res.data,
          gpHref: null
        }))
      })
    }

    if (admit.patientId) {
      API.getPatientsAdditionalData([admit.patientId])
          .then(data => {
            if(data && data[0] && data[0]?.other?.household && patientAge < 18 && !admit.household) {
              setAdmit(prevState => ({
                ...prevState,
                household: data[0]?.other?.household
              }))
            }
            if (data && data[0] && data[0]?.other?.patientFlags && !admission?.patientFlags) {
              setAdmission(prevState => ({
                ...prevState,
                patientFlags: data[0]?.other?.patientFlags
              }))
            }
          });
    }
  }, [admit.gpHref, admit.gp, admit.dob])

  useEffect(() => {
    if (admission?.cpIs) {
      setAdmit(prevState => ({
        ...prevState,
        cpIs: admission?.cpIs,
        cpIsAlertPresent: admission?.cpIsAlertPresent,
      }));
    }
  }, [admission?.cpIs]);

  useEffect(() => {
    if (admit.surgeryHref && !admit.surgery) {
      API.getSurgeryDetails(admit.surgeryHref).then((res) => {
        if (!res) {
          return renderInfoSnackbar("Please update Surgery details.");
        }

        setAdmit((pr) => ({
          ...pr,
          surgery: res,
          surgeryHref: null
        }))
      })
    }
  }, [admit.surgeryHref, admit.surgery])

  const searchPatients = (input) => {
    setOptions((pr) => ({
      ...pr,
      text: input,
    }));
  };

  const findEthnicGroup = (code) => {
    if (_.isEmpty(ethnicOptions)) {
      return null;
    }

    return ethnicOptions.find((ethnicGroup) => ethnicGroup.__code === code);
  };

  const sortBy = (type) => {
    let newSort = sort;

    if (newSort["type"] === type)
      newSort = {
        type: type,
        direction: !newSort.direction,
      };
    else
      newSort = {
        type: type,
        direction: true,
      };

    // setSort(newSort);
    // setOptions((pr) => ({
    //   ...pr,
    //   sort: (newSort.direction ? "" : "!") + newSort.type,
    // }));
  };

  const handleOpenPatientRecord = (e, patient) => {
    const disableOpenPatient = e.target.closest('.disabled-options') !== null;
    if (!disableOpenPatient && !completedFormSearch && !openDetails) {
      if (isShowPreviousAttendances) openHistoryDialog(patient);
      else {
        patientRef.current = patient;
        openCreatePatientDialog();
      }
    }
  };

  const handleOpenPatient = (patient) => {
    openHistoryDialog(patient);
  }

  const handleCopyPtNumber = (number) => {
    if (!navigator.clipboard || !number) return;
    navigator.clipboard.writeText(number)
        .then(() => {
          dispatch(setSnackbar({type: "success", message: "The patient number has been copied to the clipboard."}));
        });
  };

  const patientDOB = (patient) => {
    if (patient) {
      const dob = moment(patient.dob);
      return dob.format(config.defaultDateFormat);
    }
    return "";
  };

  const patientYears = (patient) => {
    if (patient) {
      return moment().diff(moment(patient.dob), "years");
    }
    return "";
  };

  const openHistoryDialog = (patient) => {
    dispatch(sendUserAudit({patient}, AUDIT_TYPES.OPEN_PATIENT_CONTEXT));
    history.push('/patient-context/' + patient?.__id);
  };

  const handleProceedToSpeedReg = () => {
    setSpeedRegFlag(true);
    setActiveStep((prevState) => prevState + 1);
    dispatch(setMergeQueuePatient(null));
  };

  const handleConfirmDemographics = () => {
    if (admit) {
      let tags = _.cloneDeep(admit?.tags);
      tags = _.filter(tags, t => t !== "fastRegistry");

      const date = moment().toISOString();
      const data = [{
        "metadata.ptUpdate": {
          by: tester,
          login: userObject?.userName,
          when: date,
        },
      }];
      const note = [{text: Notes.getConfirmDemographicsNote(tester, date), type: "metadata.ptUpdate"}];

      Api.updatePatientTags(ptFormPriority?.patient?.__id, tags)
          .then(res => {
            setAdmit(prevState => ({
              ...prevState,
              tags,
            }));

            Api.updatePatientInWard(ptFormPriority?.__id, data).then(response => {
              if (response.status === 200 && response.data === true) {
                dispatch(addNotesForPatient(ptFormPriority?.__id, ptFormPriority?.patient?.__id, ptFormPriority?.admission?.consultantEpisodeId, note));
              }
            });
          })
          .catch(e => {
            console.error(e);
            dispatch(setSnackbar({type: "error", message: "Patient update failed."}));
          })
          .finally(() => closeConfirmDemographics());
    }
  };

  const getAttendanceValues = async (patient, ptFromPriority) => {
    const activeAttendance = patient.activeAttendances[patient.activeAttendances.length - 1];
    const patientAttendanceData = {
      attendanceId: activeAttendance.attendanceId,
      patientId: patient.hospitalNumber || patient.__id
    }
    let patientInWard = _.find(wardAttendances, (wardAtt) => wardAtt?.patient?.hospitalNumber === patient?.hospitalNumber);
    let attendanceSource, attendanceAssaultRelated, attendanceType, location, modeOfArrival, chiefComplaint, careContactIdentifier, conveyingAmbulanceOrgId, ambulanceIncidentNumber, admitDate, cpIs, cpIsAlertPresent;
    try {
      const attendanceData = await API.getPatientAttendance(patientAttendanceData).then(res => res?.[0]);
      if (!patientInWard && ptFromPriority) patientInWard = ptFromPriority;

      if (attendanceData) {
        const historyOfPresentingComplaint = SelectPatientParser.getHistoryOfPresentingComplaint(patientInWard);
        const attendanceIdFromPAS = attendanceData?.__id;

        let the111flag;
        let majorTraumaFlag;
        const escortArray = patientInWard?.metadata?.escort || [];
        const patientFlags = patientInWard?.metadata?.patientFlags || [];
        let attendanceCategory = patientInWard?.metadata?.attendanceCategory || null;

        if (attendanceCategory && attendanceCategory?.code && !attendanceCategory?.__code) {
          attendanceCategory = _.find(attendanceCategoryDict, {__code: attendanceCategory?.code}) || null
        }

        if (!_.isEmpty(patientFlags)) {
          the111flag = patientFlags.find((flag) => flag?.name === "111");
          majorTraumaFlag = patientFlags.find((flag) => flag?.name === "majorTrauma");
        }

        if (!_.isEmpty(arrivalModeOptions)) {
          modeOfArrival = arrivalModeOptions.find((option) => option.__code === attendanceData?.arrivalModeCode);
        }

        if (!_.isEmpty(chiefComplaintOptions)) {
          chiefComplaint = chiefComplaintOptions.find((option) => option.__code === attendanceData?.initialAEComplaintCode);
        }

        if (!_.isEmpty(attendanceSourceOptions)) {
          attendanceSource = attendanceSourceOptions.find((option) => option.snomedCode === attendanceData?.admitSourceCode);
        }

        if (!_.isEmpty(attendanceTypeOptions)) {
          attendanceType = attendanceTypeOptions.find((option) => option.__code === attendanceData?.admissionTypeCode);
        }

        if (!_.isEmpty(locationOptions)) {
          location = locationOptions.find((option) => option.__code === attendanceData?.attendanceType)
        }

        if (attendanceData.careContactIdentifier) {
          careContactIdentifier = attendanceData.careContactIdentifier;
        }

        if (attendanceData.conveyingAmbulanceOrgId) {
          conveyingAmbulanceOrgId = attendanceData.conveyingAmbulanceOrgId;
        }

        if (attendanceData.ambulanceIncidentNumber) {
          ambulanceIncidentNumber = attendanceData.ambulanceIncidentNumber
        }

        if (attendanceData?.attendanceAssaultRelated) {
          attendanceAssaultRelated = attendanceData?.attendanceAssaultRelated || false;
        }

        if (attendanceData.startDate) {
            admitDate = moment(attendanceData.startDate);
        }

        if (attendanceData?.cpisFlag) {
          cpIs = true;
          cpIsAlertPresent = attendanceData?.cpisFlag === "Y";
        }

        let updatedAdmissionObj = {
          attendanceSource,
          attendanceType,
          location,
          modeOfArrival,
          chiefComplaint,
          careContactIdentifier,
          conveyingAmbulanceOrgId,
          ambulanceIncidentNumber,
          historyOfPresentingComplaint,
          lastAttendanceId: attendanceIdFromPAS,
          admitDate,
          cpIs,
          cpIsAlertPresent,
          escortArray,
          patientFlags,
          attendanceCategory,
          assaultRelated: attendanceAssaultRelated
        }

        if (the111flag) {
          updatedAdmissionObj = {
            ...updatedAdmissionObj,
            flag111: the111flag?.checked
          }
        }

        if (the111flag?.when111 && the111flag?.checked) {
          updatedAdmissionObj = {
            ...updatedAdmissionObj,
            flag111Timestamp: moment(the111flag?.when111),
          }
        }

        if (majorTraumaFlag) {
          updatedAdmissionObj = {
            ...updatedAdmissionObj,
            majorTraumaFlag: majorTraumaFlag?.checked,
          }
        }

        setAdmission(prevState => ({
          ...prevState,
          ...updatedAdmissionObj
        }))
      }
    } catch (e) {
      console.error(e);
    }
  }

  const getWardsAttendances = () => {
    const wardsIds = [];
    _.forEach(config.modules?.map?.customMapConfig, hosp => {
      wardsIds.push(`ED##${hosp?.hospitalId}`);
    });

    API.getWardsAttendances(wardsIds).then(r => {
      setWardAttendances(r);
      }
    ).catch(() => console.log("Error getting ward attendances."))
  }

  const selectPatient = (patient, ptFromPriority) => {
    checkIfPatientOnWhiteboard(patient);

    const baseAdmitState = admitBase();

    // const homeAddressIndex = patient.addresses?.findIndex(address => address?.typeName === "Home");
    const homeAddressIndex = patient.addresses?.findIndex(address => address?.typeName === "H" || address?.typeName === 'Home');
    const homeAddress = patient.addresses?.[homeAddressIndex];

    const temporaryAddressIndex = patient.addresses?.findIndex(address => address?.typeName === "TMP" || address?.typeName === "Temporary");
    const temporaryAddress = patient.addresses?.[temporaryAddressIndex];

    const [ street, city, postTown, county ] = SelectPatientParser.getAddresses(
        homeAddress?.lines ? homeAddress?.lines : homeAddress?.addressLines
        // homeAddress?.addressLines
    );

    const [streetTemporary, cityTemporary, postTownTemporary, countyTemporary] = SelectPatientParser.getAddresses(
        temporaryAddress?.lines ? temporaryAddress?.lines : temporaryAddress?.addressLines, true
    );

    const selectedPatient = {
      ...baseAdmitState,
      patientId: patient.__id,
      hospitalNumber: SelectPatientParser.getHospitalNumber(patient) || patient.hospitalNumber,
      nhsNumber: SelectPatientParser.getNHSNumber(patient),
      firstName: patient.firstName,
      middleNames: patient.middleNames || "",
      familyName: patient.familyName,
      dob: moment(patient.dob),
      ethnicGroup: patient.ethnicGroup
        ? findEthnicGroup(patient.ethnicGroup.__code)
        : null,
      gender: findGender(patient.genderCode),
      addressLines: patient.addressLines ? patient.addressLines : "",
      city: city,
      county: county,
      postTown: postTown,
      street: street,
      patientNeedsInterpreter: patient.interpreterRefused ? null : (patient.interpreterRequired || false),
      spokenLanguage: patient.primaryLanguageCode
          ? _.find(languageOptions, {__code: patient.primaryLanguageCode}) : baseAdmitState.spokenLanguage,
      spokenLanguageExists: !!patient.primaryLanguageCode,
      interpreterLanguage: patient.interpreterLanguageCode
          ? _.find(languageOptions, {__code: patient.interpreterLanguageCode}) : baseAdmitState.interpreterLanguage,
      postalCode: homeAddress ? homeAddress?.postalCode : patient?.postalCode || "",
      ehicNumber: SelectPatientParser.getEhicNumber(patient),
      occupation: patient.occupation ? patient.occupation : "",
      phoneNumbers: SelectPatientParser.getPhoneNumbers(patient),
      gpHref: SelectPatientParser.getGPId(patient),
      surgeryHref: SelectPatientParser.getSurgeryId(patient),
      nokList: SelectPatientParser.getNextOfKins(patient),
      emailAdresses: SelectPatientParser.getEmail(patient),
      school: patient.school ? patient.school : "",
      schoolName: patient.schoolName
        ? patient.schoolName
        : patient.school
        ? patient.school.name
        : "",
      schoolContact: patient.schoolContact
        ? patient.schoolContact
        : patient.school
        ? patient.school.contact
        : "",
      schoolAddress: patient.schoolAddress
        ? patient.schoolAddress
        : patient.school
        ? patient.school.address.addressLines.join(", ")
        : "",
      schoolPostalCode: patient.schoolPostalCode
        ? patient.schoolPostalCode
        : patient.school
        ? patient.school.address.postalCode
        : "",
      tags: patient?.tags ? patient?.tags : [],
      overseasStatus: patient?.overseasVisitorChargingCategory || null,
      accommodationStatus: patient?.accommodationStatus || null,
      activeAttendances: _.filter(patient?.activeAttendances, att => att?.attendanceType === 'E'),
      streetTemporary,
      cityTemporary,
      postTownTemporary,
      countyTemporary,
      postalCodeTemporary: temporaryAddress?.postalCode ? temporaryAddress?.postalCode : null,
  };

    if (patient?.patientNumbers) {
      setPatientNumbers(patient.patientNumbers);
    }

    if (selectedPatient?.postalCode && _.startsWith(selectedPatient?.postalCode, 'ZZ99')) {
      setToggleNFA(true);
    }
    if (selectedPatient?.postalCodeTemporary && _.startsWith(selectedPatient?.postalCodeTemporary, 'ZZ99')) {
      setToggleNFATemporary(true);
    }

    setAdmit(selectedPatient);

    if (!_.isEmpty(selectedPatient?.activeAttendances)) {
      getAttendanceValues(selectedPatient, ptFromPriority);
    }

    setPatientIsSelected(true);
    setActiveStep(1);
    setPatients(null);

    if (
      !fastRegFlag &&
      (!patient.gender ||
        (patient.gender &&
          patient.gender !== "Male" &&
          patient.gender !== "Female"))
    ) {
      openGenderMandatoryDialog();
    }

    if (!fastRegFlag && !speedRegFlag) {
      renderInfoSnackbar(`Please make sure to check if patient' data is up to date`)
    }
  };

  const generatePdf = (pt, form) => {
    APIForm.generatePdf(pt, form)
        .then(res => {
          if (res) {
            const blob = new Blob([res], {type: "application/pdf"});
            let objectURL = window.URL.createObjectURL(blob);
            window.open(objectURL, "_blank");
          }
        })
        .catch(err => {
          dispatch(setSnackbar({type: "error", message: "The document could not be generated."}));
        });
  };

  const redderFelicityCompletedForms = (pt) => {
    const forms = config?.modules?.formSearch?.formList || [];
    let facility = null;

    _.forEach(forms, form => {
      if (facility) return;

      let completedForm = null;
      const formData = _.find(formsData, {id: form});
      if (formData) completedForm = _.find(formData.forms, f => f.hospital === pt.__id);

      if (completedForm) facility = completedForm?.facility;
    });

    if (facility) facility = facility === 'R0D01' ? 'PHT' : 'RBH';

    return facility || '-';
  }

  const redderCompletedForms = (pt) => {
    const forms = config?.modules?.formSearch?.formList || [];
    const formsDisplayName = config?.modules?.formSearch?.formsDisplayName || {};
    return (
        <div className={classes.divRow}>
          {forms.map(form => {
            let completedForm = null;
            const formData = _.find(formsData, {id: form});
            if (formData) completedForm = _.find(formData.forms, f => f.hospital === pt.__id);

            let formName = formsDisplayName[form]? formsDisplayName[form]: _.startCase(form);

            const tooltip = completedForm
                ? `${formName} completed ${moment(completedForm?.__lastModifiedDate).format(config.defaultDateTimeFormat)}`
                : formName;

            return (
                <Tooltip title={tooltip} key={form}>
                  <span>
                    <IconButton
                        size="small"
                        disableRipple
                        onClick={generatePdf.bind(this, pt.__id, completedForm)}
                        disabled={!completedForm}
                    >
                      <PictureAsPdfIcon/>
                    </IconButton>
                    </span>
                </Tooltip>
            );
          })}
        </div>
    );
  };

  const getFacility = (pt) => {
    const find = _.find(patientsFacilities, {id: pt?.__id});
    if (find && config?.modules?.map?.customMap) {
      return <span style={{marginRight: 5}}>({find?.location === 'R0D01' ? 'PHT' : 'RBH'})</span>;
    }
    return null;
  };

  const renderPatientsList = () => {
    let patientsList = [];
    let patientsSorted = patients;

    patientsSorted =
      patients && patientsSorted.filter((patient) => !_.isEmpty(patient));

    if (patientsSorted && patientsSorted.length > 0) {
      patientsList.push(
        <div
          key="header"
          className={`${completedFormSearch ? "patients-list-grid-extended" : "patients-list-grid"} ` + classes.tableHeader}
        >
          <div
            onClick={sortBy.bind(this, "familyName")}
            className={classes.fullNameHeader + " " + classes.sortedHeader}
          >
            <div className={classes.headerText}>{t("Last Name")}</div>
            {sort.type === "familyName" && sort.direction && (
              <ArrowDropDownIcon />
            )}
            {sort.type === "familyName" && !sort.direction && (
              <ArrowDropUpIcon />
            )}
          </div>

          <div
            onClick={sortBy.bind(this, "firstName")}
            className={classes.sortedHeader}
          >
            <div className={classes.headerText}>{t("First Name")}</div>
            {sort.type === "firstName" && sort.direction && (
              <ArrowDropDownIcon />
            )}
            {sort.type === "firstName" && !sort.direction && (
              <ArrowDropUpIcon />
            )}
          </div>

          <div
            onClick={sortBy.bind(this, "dob")}
            className={classes.sortedHeader}
          >
            <div className={classes.headerText}>{t("Born")}</div>
            {sort.type === "dob" && sort.direction && <ArrowDropDownIcon />}
            {sort.type === "dob" && !sort.direction && <ArrowDropUpIcon />}
          </div>

          <div
            onClick={sortBy.bind(this, "gender")}
            className={classes.sortedHeader}
          >
            <div className={classes.headerText}>{t("Gender")}</div>
            {sort.type === "gender" && sort.direction && <ArrowDropDownIcon />}
            {sort.type === "gender" && !sort.direction && <ArrowDropUpIcon />}
          </div>

          <div
            onClick={sortBy.bind(this, "id")}
            className={classes.sortedHeader}
          >
            <div className={classes.headerText}>{t("Hospital Number")}</div>
            {sort.type === "id" && sort.direction && <ArrowDropDownIcon />}
            {sort.type === "id" && !sort.direction && <ArrowDropUpIcon />}
          </div>

          <div
            onClick={sortBy.bind(this, "nhs")}
            className={classes.sortedHeader}
          >
            <div className={classes.headerText}>{t("NHS Number")}</div>
            {sort.type === "nhs" && sort.direction && <ArrowDropDownIcon />}
            {sort.type === "nhs" && !sort.direction && <ArrowDropUpIcon />}
          </div>

          <div className={classes.headerText}>{t("More Information")}</div>

          {completedFormSearch &&
              <>
                <div className={classes.headerText}>
                  {t('Hospital')}
                </div>

                <div className={classes.headerText}>
                  {t('Completed Forms')}
                </div>
              </>
          }
        </div>
      );

      _.forEach(patientsSorted, (patient, index) => {
        const haveActiveAtt = patient?.activeAttendances
            ? !_.isEmpty(_.filter(patient?.activeAttendances, pt => pt?.attendanceType === "E" && _.isNil(pt?.endDate)))
            : false;
        const haveBedasAtt = patient?.tags ? patient?.tags.includes("bedas") : false;
        const isTemporary = patient?.tags ? patient?.tags.includes("temporary") : false;
        const isDeceased = patient && (patient?.tags?.includes("deceased") || !_.isNull(patient.dod));
        const isSearchLock = patient?.tags?.includes('searchLocked');

        const handleSelectPatientFromList = (e) => {
          if (isSearchLock) {
            dispatch(setSnackbar({
              type: 'warning',
              message: 'The patient record is restricted.',
            }));
          } else if (isTemporary && !haveActiveAtt) {
            renderInfoSnackbar(`Only merging from existing patient to temporary is available.`);
          } else {
            handleOpenPatientRecord(e, patient);
          }
        };

        patientsList.push(
          <div
            key={index}
            onClick={handleSelectPatientFromList}
            className={clsx(
                `${completedFormSearch ? "patients-list-grid-extended" : "patients-list-grid"} `
                + classes.tableRecord,
                haveActiveAtt && classes.activeAttendance,
                haveBedasAtt && classes.bedasAttendance,
                isDeceased && classes.isDeceased,
            )}
          >
            <div className={classes.fullName}>
              <span className={classes.familyName}>
                {completedFormSearch &&
                    <Tooltip title={t("Open patient last attendance")}>
                      <span>
                        <IconButton
                            size="small"
                            disableRipple
                            onClick={handleOpenPatient.bind(this, patient)}
                            disabled={!dispatch(hasPermission(Permissions.AGYLE_CAN_OPEN_PATIENT_RECORD))}
                        >
                          <ContactPageIcon fontSize="small" style={{marginRight: 5}}/>
                        </IconButton>
                      </span>
                    </Tooltip>
                }

                {haveActiveAtt &&
                    <>
                      <Tooltip title={t("Patient have active attendance")}>
                        <SmartDisplayIcon style={{marginRight: 5}}/>
                      </Tooltip>
                      {getFacility(patient)}
                    </>
                }

                {haveBedasAtt &&
                    <Tooltip title={t("Patient bedas attendance")}>
                      <AgyleNamedIcon name="bedReady" style={{marginRight: 5}}/>
                    </Tooltip>
                }
                {patient?.vip && <div className={classes.vvip}>VVIP</div>}
                {patient?.familyName}
                {patient?.title && <span> ({patient?.title})</span>}
                {isTemporary && <Chip color="info" size="small" label={t('Temporary')} style={{marginLeft: 5}}/>}
              </span>
            </div>

            <div>{patient?.firstName}</div>

            <div>
              {patientDOB(patient)} ({patientYears(patient)} {t("years")})
            </div>

            <div>{patient?.gender}</div>

            <div className="disabled-options">
              <Tooltip title={t("Copy Patient ID")}>
                <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCopyPtNumber(patient?.hospitalNumber);
                    }}
                    size="small"
                >
                  <CopyIcon/>
                </IconButton>
              </Tooltip>
              {patient?.hospitalNumber}
            </div>

            <div className="disabled-options">
              {patient?.nhsNumber &&
                <Tooltip title={t("Copy Patient NHS No")}>
                  <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopyPtNumber(patient?.nhsNumber);
                      }}
                      size="small"
                  >
                    <CopyIcon/>
                  </IconButton>
                </Tooltip>
              }

              {patient?.nhsNumber || 'Not provided'}
            </div>

            <div className="disabled-options" style={{position: 'relative'}}>
              <PatientInfo
                  patient={patient}
                  header={false}
                  admit
                  handleOpenModals={setOpenDetails}
                  fromSearch
                  additionalData={patientsData}
                  searchLock={isSearchLock}
              />
            </div>

            {completedFormSearch &&
                <>
                  <div className="disabled-options">
                    {redderFelicityCompletedForms(patient)}
                  </div>

                  <div className="disabled-options">
                    {redderCompletedForms(patient)}
                  </div>
                </>
            }
          </div>
        );
      });
    } else if (patients) {
      patientsList.push(
        <div key="nocontennt">
          {t(
            "Unfortunately we cannot find what you are looking for. Please adjust your search criteria"
          )}
        </div>
      );
    }

    return patientsList;
  };

  const handlePageChange = (e, pageNumber) => {
    setPage(pageNumber);
    setOptions((pr) => ({
      ...pr,
      page: pageNumber,
    }));
  };

  const createNewPatient = (onlyPatient = false) => {
    if (patientRef.current) {
      selectPatient(patientRef.current);
    }
    onlyPatient && !isCreatePatientDialogOpen ? setIsAddOnlyPatient(true) : closeCreatePatientDialog();
    setActiveStep(1);
    patientRef.current = null;
    dispatch(setMergeQueuePatient(null));
  };

  const handleUpdateDemographic = () => {
    if (patientRef.current) {
      selectPatient(patientRef.current);
    }
    closeCreatePatientDialog();
    setActiveStep(1);
    patientRef.current = null;
    setOnlyDemographic(true);
    dispatch(setMergeQueuePatient(null));
  }

  const addBedBooking = () => {
    if (patientRef.current) {
      selectPatient(patientRef.current);
    }
    setIsBedBookingChosen(true);
    setActiveStep(1);
    closeCreatePatientDialog();
    patientRef.current = null;
    dispatch(setMergeQueuePatient(null));
  };

  const reAttendance = () => {
    if (patientRef.current) {
      selectPatient(patientRef.current);
    }
    setIsReAttendance(true);
    setActiveStep(1);
    closeCreatePatientDialog();
    patientRef.current = null;
    dispatch(setMergeQueuePatient(null));
  };

  const handleBedas = () => {
    if (patientRef.current) {
      selectPatient(patientRef.current);
    }
    setIsBedas(true);
    setActiveStep(1);
    closeCreatePatientDialog();
    patientRef.current = null;
  };

  const handleMergeTo = () => {
    if (patientRef.current) {
      setTemporaryMergePt(patientRef.current?.hospitalNumber);
      patientMergeRef.current = patientRef.current;
    }
    closeCreatePatientDialog();
    openTemporaryPatientEdit();

    patientRef.current = null;
  };

  const handleMergeTemporary = (isSame, removeBedas) => {
    const state = {
      temporaryId: patientToMerge?.patient?.__id,
      validId: isSame ? '' : patientRef.current?.__id,
    };

    setBedasRemove(removeBedas);

    // here add state to check if handles merge to new created patient
    if (isSame) {
      setMergeToNewCreatedPatient(true);
    };
    handleEditTemporaryPatient(state);
    closeCreatePatientDialog();
    patientRef.current = null;
    dispatch(setMergeQueuePatient(null));
  };

  const checkIfPatientIsTemporary = (patient) => {
    let patientTags;
    if (!patient) {
      return false;
    }
    if (patient.tags) {
        patientTags = patient.tags;
    }
    return patientTags &&( patientTags.includes("temporary") || patientTags.includes("unknown"));
  }

  const findPatient = async (patientId) => {
    try {
      const patient = await API.getPatientByID(patientId);
      if (!patient) {
        renderErrorSnackbar(`Patient with ID ${patientId} has not been found.`);
        return;
      }
      return patient;
    } catch (error) {
      renderErrorSnackbar("Something went wrong. Please try again later.");
    }
  }

  const getBothPatients = async (state) => {
    const temporaryId = state.temporaryId;
    const validId = state.validId;
    if (temporaryId === validId) {
      renderErrorSnackbar("Temporary and valid IDs cannot be the same.");
      return;
    }

    try {
      const patients = await Promise.all([
          findPatient(temporaryId), findPatient(validId)
      ])
      return patients;
    } catch (e) {
      renderErrorSnackbar("Something went wrong. Please try again later.");
    }
  }

  const handleCloseTemporaryPatient = () => {
    closeTemporaryPatientEdit();
    if (temporaryMergePt) setTemporaryMergePt(null);
  };

  const getTemporaryPatientAttendance = async (tempPatient, lastAttendance) => {
    const patientAttendanceData = {
      attendanceId: lastAttendance.attendanceId,
      patientId: tempPatient.hospitalNumber || tempPatient.__id
    }
    try {
      const attendance = await API.getPatientAttendance(patientAttendanceData)
          .then(res => res[0])
          .catch((e) => {
            tempPt.current = tempPatient;
            openAttErrorDownload();
            console.error(`getPatientAttendance Pt ID ${tempPatient?.__id}`, e);
          });
      temporaryPatientAttendanceRef.current = attendance;
      if (attendance) {
        getAttendanceValues(temporaryPatientRef.current)
      }

    } catch (e) {
      console.log(e)
    }
  }

  const getLastAttendance = (patient) => {
    if(patient && patient?.activeAttendances) {
      const lastActiveAttendance = patient.activeAttendances[patient.activeAttendances.length - 1];
      getTemporaryPatientAttendance(patient, lastActiveAttendance)
    }
  }

  useEffect(() => {
    getLastAttendance(temporaryPatientRef.current)
  }, [temporaryPatientRef.current])

  const handleEditTemporaryPatient = async (state) => {
    if (!state.temporaryId && state.temporaryId === state.validId) {
      renderErrorSnackbar(t("Please fill at least Temporary Patient ID field to proceed."));
      return;
    }

    try {
      if (state?.temporaryId && !state?.validId) {
        await findPatient(state.temporaryId).then(patient => {
          if (!patient) return;

          if (!patient.tags || (patient.tags && (!patient.tags.includes("temporary") && !patient.tags.includes("unknown")))) {
            renderErrorSnackbar("The patient you are trying to edit is not temporary.");
            return;
          }

          temporaryPatientRef.current = patient;
          selectPatient(patient);
          setPatientIsSelected(true);
          setIsTemporaryPatientEdit(true);
          closeTemporaryPatientEdit();
          return patient;
        });
      }

      if (state?.temporaryId && state?.validId) {
        getBothPatients(state).then(patients => {

        if (patients[0] && !checkIfPatientIsTemporary(patients[0])) {
          renderErrorSnackbar("The patient you are trying to edit is not temporary.");
          return;
        }

        getLastAttendance(patients[0])

        temporaryPatientRef.current = patients[0];
        selectPatient(patients[1]);
        closeTemporaryPatientEdit();
        setTemporaryMergePt(null);
        });
      }
    } catch (e) {
      console.log("Something went wrong. Please try again later.")
    }
  }

  const handleSearchCompletedForms = () => {
    dispatch(setLoadingGlobal(true));
    setPatients([]);
    const obj = {
      from: startDateForm,
      to: endDateForm,
      forms: searchedForms,
    }

    APIForm.getCompletedForms(obj)
        .then(res => {
          if (res?.forms) {
            const filteredData = filterFormData(res.forms);
            setFormsData(filteredData);
            const ptIds = new Set();
            _.forEach(filteredData, form => {
              _.forEach(form.forms, innerForm => {
                ptIds.add(innerForm.hospital);
              });
            });

            if (!_.isEmpty(ptIds)) {
              const test = Formatter.setToString(ptIds, ",")
              ids.current = Array.from(ptIds);
              searchPatients(test);
            }
          }
        })
        .catch(error => {
          dispatch(setSnackbar({type: "error", message: "An error occurred while searching."}));
        })
        .finally(() => {
          dispatch(setLoadingGlobal(false));
        });
  };

  const filterFormData = (forms) => {
    let clone = _.cloneDeep(forms);

    _.forEach(clone, form => {
      if (!_.isEmpty(form?.forms)) {
        form.forms = _.filter(form.forms, f => _.isNil(f?.facility) || f?.facility === hospital?.hospitalId);
      }
    });

    return clone;
  };

  const handleChangeFromsToSearch = (val) => {
    setSearchedForms(val);
  }

  const getFromsToSearch = () => {
    if (config?.modules?.formSearch?.formList) {
      const forms = [];
      const formsDisplayName = config?.modules?.formSearch?.formsDisplayName || {};

      _.forEach(config?.modules?.formSearch?.formList, f => {
        let formName = formsDisplayName[f] ? formsDisplayName[f] : _.startCase(f);
        forms.push({
          id: f,
          name: formName,
        });
      })

      return forms;
    }

    return [];
  };

  const renderChip = (selected) => {
    const formsDisplayName = config?.modules?.formSearch?.formsDisplayName || {};
    const getFormName = (id) => formsDisplayName[id] ? formsDisplayName[id] : _.startCase(id);

    return (
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
          {selected?.map((value) => (
              <Chip key={value} label={getFormName(value)}/>
          ))}
        </Box>
    );
  };

  const handleClosePatientDialogOpen = () => {
    closeCreatePatientDialog();
    patientRef.current = null;
  };

  const renderPatientSearch = () => {
    return (
      <Paper>
        <div className={classes.content}>
          <Grid container spacing={1} sx={{ my: 2 }}>
            <Grid container spacing={2} sx={{ m: 2 }} justifyContent="flex-end">
              <Grid item xs={11}>
                <div className={classes.previousAttendancesContainer}>
                  <AgyleBlockSwitch
                    value={isShowPreviousAttendances}
                    onChange={() =>
                      setIsShowPreviousAttendances((prevState) => !prevState)
                    }
                  />

                  <FormLabel sx={{ mr: 3 }}>
                    {t("Go to Patient Context")}
                  </FormLabel>

                  {config?.admitPatient?.fastRegistryEnabled &&
                    <>
                      <AgyleBlockSwitch
                          value={fastRegFlag}
                          onChange={() => setFastRegFlag((prevState) => !prevState)}
                      />

                      <FormLabel sx={{ mr: 3 }}>{t("Fast Registry")}</FormLabel>
                    </>
                  }

                  {config?.modules?.formSearch?.enabled &&
                      <>
                        <AgyleBlockSwitch
                            value={completedFormSearch}
                            onChange={() => setCompletedFormSearch((prevState) => !prevState)}
                        />

                        <FormLabel sx={{mr: 3}}>{t("Search Completed Forms")}</FormLabel>
                      </>
                  }
                </div>

                {(config?.modules?.formSearch?.enabled && completedFormSearch) &&
                    <Grid container direction="row" className={classes.divRow} spacing={2} style={{marginTop: 5, flexWrap: 'wrap'}}>
                      <Grid item xs={6} md={3}>
                        <AgyleDatePicker
                            label={t("Search From")}
                            onChange={setStartDateForm}
                            value={startDateForm}
                            type="dateTime"
                            maxDate={moment()}
                            size="medium"
                        />
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <AgyleDatePicker
                            label={t("Search To")}
                            onChange={setEndDateForm}
                            value={endDateForm}
                            type="dateTime"
                            maxDate={moment()}
                            size="medium"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <AgyleSelectField
                            onChange={handleChangeFromsToSearch}
                            options={getFromsToSearch()}
                            value={searchedForms}
                            label={t("Form to Search")}
                            withBackground
                            padding="12px"
                            multiple
                            multipleInputRender={renderChip}
                            size="large"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={2}>
                        <AgyleButton
                            size="large"
                            onClick={handleSearchCompletedForms}
                            style={{marginLeft: "auto"}}
                            disabled={_.isEmpty(searchedForms)}
                        >
                          {t("Search Completed Forms")}
                        </AgyleButton>
                      </Grid>
                    </Grid>
                }

                <div className={classes.searchInput}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                  <FiledWithHistory
                    placeholder={t(
                      "You can search by patient name, hospital number or NHS number"
                    )}
                    handleSubmit={handleSubmit}
                    history={admitSearch}
                    saveHistory={handleHistoryChange}
                    disabled={completedFormSearch}
                    value={searchValue}
                  />
                </div>
              </Grid>

              <Grid
                item
                xs={1}
                style={{
                  flexBasis: "content",
                  paddingBottom: "20px",
                  alignSelf: "flex-end",
                }}
              >
                <SearchHint />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ m: 4 }}>
            {loading &&
              <div style={{
                textAlign: "center",
                fontWeight: "bold"
              }}>
                <h2>{"Loading data. Please wait."}</h2>
                <CircularProgress/>
              </div>
            }
            {!loading && <div className={classes.patientsTable}>{renderPatientsList()}</div>}
          </Grid>

          {isCreatePatientDialogOpen && (
            <Dialog
              open={isCreatePatientDialogOpen}
              onClose={handleClosePatientDialogOpen}
              fullWidth
              maxWidth="sm"
            >
              <ChooseRegistrationStep
                onClose={handleClosePatientDialogOpen}
                patient={patientRef}
                onCreateNewPatient={createNewPatient}
                onUpdateDemographic={handleUpdateDemographic}
                onAddBedBooking={addBedBooking}
                onReAttendance={reAttendance}
                onBedas={handleBedas}
                mergInTo={handleMergeTo}
                mergeTemporary={handleMergeTemporary}
                hospital={hospital}
                patientsFacilities={patientsFacilities}
              />
            </Dialog>
          )}

          <EditTemporaryPatientModal
              open={isTemporaryPatientEditOpen}
              onClose={handleCloseTemporaryPatient}
              onSubmit={handleEditTemporaryPatient}
              destinationPatient={temporaryMergePt}
              patientRef={patientMergeRef.current}
          />
        </div>
      </Paper>
    );
  };

  const checkRequiredDemographicFields = () => {
    const requiredFields = [
      "firstName",
      "familyName",
      "dob",
      "gender",
      "ethnicGroup",
      "addressLines",
      "postalCode",
    ];
    if (isChild(patientAge)) {
      requiredFields.push(
        "schoolName",
        "schoolAddress",
        "schoolPostalCode",
        "cpIs",
        "cpIsAlertPresent"
      );
    }
    return requiredFields.every((field) => {
      return !_.isUndefined(admit[field]);
    });
  };

    const nhsNumberValid = () => {
        const patientNhsFunded = admit?.overseasStatus && admit?.overseasStatus?.__code === 'A';
        if (patientNhsFunded) {
          return !admit?.nhsNumber || admit?.nhsNumber.length < 10;
        }
    }

  const checkFields = useCallback(() => {
  // const checkFields = () => {
    const {
      firstName,
      familyName,
      dob,
      ehicCard,
      noEhicReason,
      ehicNumber,
      street,
      streetTemporary,
      cityTemporary,
      postalCode,
      postalCodeTemporary,
      overseasStatus,
      nhsBlockedProceeding
    } =
      admit;
    let nokIsValid = true;
    let ehicIsValid = true;
    let isGenderValid = true;
    let addressIsValid = true;
    let temporaryAddressIsValid = true;

    let schoolDetailsIsValid = true;
    let phoneIsValid = true
    let ethnicIsValid = true;
    let gpIsValid = true;
    let overseasStatusIsValid = true;

    if (!admit.ethnicGroup) {
      ethnicIsValid = false;
    }

    if (!admit.gp || !admit.surgery) {
      gpIsValid = false;
    }

    if (isChild(patientAge) && !admit.schoolName) {
      schoolDetailsIsValid = false
    }

    if (_.isEmpty(admit.phoneNumbers) && !config?.admitPatient?.contactNumbersReadOnly && config?.admitPatient?.contactNumberMandatory) {
      phoneIsValid = false;
    }

    if ((!_.isNil(streetTemporary) || !_.isNil(postalCodeTemporary)) && (!streetTemporary || !postalCodeTemporary || (!validTemporaryPostCode && !toggleNFATemporary))) {
      temporaryAddressIsValid = false
    }

    if (!overseasStatus) {
        overseasStatusIsValid = false;
    }

    if (_.isEmpty(admit.nokList)) {
      nokIsValid = false;
    }

    if (!_.isEmpty(admit.nokList)) {
      nokIsValid = admit.nokList.every((nok) => nok.relationship && (config?.admitPatient?.nokContactNumberMandatory ? nok?.phoneNumber : true));
    }

    if (!admit.gender) {
      isGenderValid = false;
    }

    if (admit.gender) {
      if (
        admit.gender.__description !== "Male" &&
        admit.gender.__description !== "Female"
      )
        isGenderValid = false;
    }

    if (ehicCard !== null) {
      if (ehicCard === true) {
        ehicIsValid = ehicNumber ? true : false;
      }
      if (ehicCard === false) {
        ehicIsValid = noEhicReason ? true : false;
      }
    }


    if ((!street || !postalCode || (!validPostCode && !toggleNFA)) && _.isNil(streetTemporary)) {
      addressIsValid = false;
    }

    if (
      !firstName ||
      !familyName ||
      !dob ||
      !addressIsValid ||
      !nokIsValid ||
      !ehicIsValid ||
      !isGenderValid ||
      !ethnicIsValid ||
      !gpIsValid ||
      !schoolDetailsIsValid ||
      !phoneIsValid ||
      !overseasStatusIsValid ||
      !temporaryAddressIsValid ||
      isPatientUpdated ||
      nhsBlockedProceeding ||
      nhsNumberValid()
    ) {
      return false;
    }
    return true;
  // }
  }, [admit, isPatientUpdated, validPostCode, validTemporaryPostCode, toggleNFA, toggleNFATemporary]);

  const handleRefreshPatientFlags = (attendanceData) => {
    let patientFlags = [
      {
        "name": "111",
        "checked": attendanceData?.flag111,
        "when111": moment.isMoment(attendanceData?.flag111Timestamp) ? attendanceData?.flag111Timestamp.toISOString() : null,
        "date": moment().toISOString(),
      },
      {
        "name": "majorTrauma",
        "checked": attendanceData?.majorTraumaFlag,
        "by": null,
        "date": moment().toISOString(),
      }]

    if (!_.isEmpty(attendanceData?.patientFlags)) {
      patientFlags = _.cloneDeep(attendanceData.patientFlags);

      const the111FlagIndex = patientFlags?.findIndex((flag) => flag?.name === "111");
      const majorTraumaFlagIndex = patientFlags?.findIndex((flag) => flag?.name === "majorTrauma");
      const bedasFlagIndex = patientFlags?.findIndex((flag) => flag?.name === "bedas");

      if (the111FlagIndex !== -1) {
        patientFlags[the111FlagIndex].checked = attendanceData?.flag111;

        if (attendanceData?.flag111Timestamp && moment.isMoment(attendanceData?.flag111Timestamp)) {
          patientFlags[the111FlagIndex].when111 = attendanceData?.flag111Timestamp.toISOString();
        }
      }

      if (majorTraumaFlagIndex !== -1) {
        patientFlags[majorTraumaFlagIndex].checked = attendanceData?.majorTraumaFlag;
        patientFlags[majorTraumaFlagIndex].date = moment().toISOString();
      }

      if (bedasFlagIndex !== -1 && isBedas) {
        patientFlags[bedasFlagIndex].checked = true;
      }
    }

    return patientFlags;
  }

  const handleGetPatientValue = (object, mode) => {
    let objToReturn = {};
    const getAddresses = (object) => {
        let addresses = [];
        if (!RequestDataParser.getAddressLines(object) && !RequestDataParser.getAddressLines(object, true)) {
          return null;
        }

        if (RequestDataParser.getAddressLines(object)) {
          addresses.push({
            typeName: "Home",
            addressLines: RequestDataParser.getAddressLines(object),
            postalCode: object.postalCode
          })
        }

        if (!_.isNil(object.streetTemporary) || !_.isNil(object.postalCodeTemporary) || object.streetTemporary || object.postalCodeTemporary) {
          addresses.push({
            typeName: "Temporary",
            addressLines: RequestDataParser.getAddressLines(object, true),
            postalCode: object.postalCodeTemporary,
          })
        }

        return addresses;
    }

    const getSchool = () => {
      if (patientAge >= 18) {
        return null;
      }
     return RequestDataParser.mapSchoolObject(object);
    }

    let ehicCardObj = {
      number:  object.ehicNumber,
      type: "EhicNumber",
      simpleType: null,
      incomingSystem: null
    };

    if ((mode === 'updateAttendance' || mode === 'updatePatient') && patientNumbers && object?.ehicNumber) {
      let localFromArr = patientNumbers && patientNumbers.find(item => item.type === 'EhicNumber' || item.simpleType === 'EhicNumber');
      if (localFromArr) {
        let localObj = {
          ...localFromArr,
          number: object.ehicNumber
        }
        ehicCardObj = localObj;
      }
    }

    const patientToRequestMap = new Map([
      ["firstName", object.firstName],
      ["middleNames", object.middleNames],
      ["familyName", object.familyName],
      ["dob", RequestDataParser.getFormattedDOB(object)],
      ["hospitalNumber", object.hospitalNumber],
      ["__id", object.hospitalNumber],
      ["nhsNumber", object.nhsNumber],
      ["gp", RequestDataParser.getGpId(object)],
      ["surgery", RequestDataParser.getSurgeryId(object)],
      ["genderCode", object?.gender?.__code],
      ['primaryLanguageCode', object?.spokenLanguage?.__code],
      ['interpreterLanguageCode', object?.interpreterLanguage?.__code],
      ['interpreterRequired', object?.patientNeedsInterpreter !== null ? Boolean(object?.patientNeedsInterpreter) : null],
      ['interpreterRefused', object?.patientNeedsInterpreter === null],
      ['accommodationStatus', object?.accommodationStatus || null],
      ["addresses", getAddresses(object)],
      ["postalCode", object.postalCode],
      ["names", object?.names],
      ["ethnicGroup", object?.ethnicGroup?.__id ? { __id: object?.ethnicGroup?.__id} : null],
      ["addressLines", RequestDataParser.getAddressLines(object)],
      ["phoneNumbers", RequestDataParser.getPhoneNumbers(object)],
      ["emails", RequestDataParser.getEmails(object)],
      ["nextOfKins", RequestDataParser.mapNextOfKinObject(object)],
      ["tags", object?.tags ? object?.tags : []],
      ["school", getSchool()],
      ['patientNumbers', object.ehicCard && object.ehicNumber ? [ehicCardObj]  : null],
      ["overseasVisitorChargingCategory", object.overseasStatus ?
          object.overseasStatus : null],
    ])

    const modeValues = {
      "selectPatient": ['firstName', 'familyName', 'dob', 'hospitalNumber', "__id"],
      'temporaryFastAttendance': ['firstName', 'familyName', 'dob', 'genderCode', '__id', "hospitalNumber"],
      'updateTemporaryPatient': ['firstName', 'middleNames', 'familyName', 'dob', 'nhsNumber', 'genderCode', 'gp',  'surgery', 'primaryLanguageCode', 'interpreterRequired', 'addresses', 'postalCode', 'ethnicGroup', 'addressLines', 'phoneNumbers', 'emails', 'nextOfKins', 'school', 'patientNumbers', 'overseasVisitorChargingCategory', 'interpreterRefused', 'interpreterLanguageCode', 'accommodationStatus', 'tags'],
      "createPatient": ['firstName', 'patientNumbers', 'middleNames', 'familyName', 'nhsNumber', 'dob', 'gp', 'surgery', 'genderCode', 'addressLines', 'postalCode', 'addresses', 'ethnicGroup', 'phoneNumbers', 'emails', 'nextOfKins', 'school', 'primaryLanguageCode', 'interpreterRequired', 'overseasVisitorChargingCategory', 'interpreterRefused', 'interpreterLanguageCode', 'accommodationStatus', 'tags'],
      'updatePatient': ['firstName', 'middleNames', 'familyName', 'dob', 'nhsNumber', 'hospitalNumber', '__id', 'genderCode', 'gp', 'surgery', 'primaryLanguageCode', 'interpreterRequired', 'addresses', 'postalCode', 'ethnicGroup', 'addressLines', 'phoneNumbers', 'emails', 'nextOfKins', 'school', 'patientNumbers', 'overseasVisitorChargingCategory', 'interpreterRefused', 'interpreterLanguageCode', 'accommodationStatus', 'tags', "names"],
      'updateAttendance': ['firstName', 'middleNames', 'familyName', 'dob', 'nhsNumber', 'hospitalNumber', '__id', 'genderCode', 'gp', 'surgery', 'primaryLanguageCode', 'interpreterRequired', 'addresses', 'postalCode', 'ethnicGroup', 'addressLines', 'phoneNumbers', 'emails', 'nextOfKins', 'school', 'patientNumbers', 'overseasVisitorChargingCategory', 'interpreterRefused', 'interpreterLanguageCode', 'accommodationStatus', 'tags', "names"],
    }

    modeValues[mode].forEach(key => {
      const value = patientToRequestMap.get(key);
      if (!_.isNil(value) && value !== "") objToReturn[key] = value;
      if (key === 'addressLines') delete objToReturn[key];
    });

    return objToReturn
  }

  const handleGetAttendanceValue = (object, mode) => {
    const getMergePatientObject = (obj) => {
      let temp = {};

      if (!temporaryPatientRef.current) {
        return
      }

      temp = {
        from: temporaryPatientRef.current.hospitalNumber
      }

      if (temporaryPatientRef.current && temporaryPatientRef.current.hospitalNumber) {
        if (temporaryPatientRef.current.hospitalNumber !== obj.hospitalNumber) {
          temp = {
            ...temp,
            to: obj.hospitalNumber
          }
        }
      }
      return temp;
    }

    const attendanceMap = new Map ([
      ["chiefComplaintCode", object.chiefComplaint?.snomedCode],
      ["historyOfPresentingComplaint", object.historyOfPresentingComplaint],
      ["ehicNotProvidedReason", !object.ehicCard ? object.ehicNotProvidedReason : null],
      ["admitDate", moment(object?.admitDate)?.toISOString()],
      ['arrivalModeCode', object.modeOfArrival?.snomedCode],
      ['attendanceSourceCode', object.attendanceSource?.snomedCode],
      ['locationCode', object.location?.__code],
      ['attendanceTypeCode', object.attendanceType?.__code],
      ['ambulanceIncidentNumber', object.ambulanceIncidentNumber],
      ['conveyingAmbulanceOrgId', object.conveyingAmbulanceOrgId],
      ['careContactIdentifier', object.careContactIdentifier],
      ['cpis', object.cpIs],
      ['cpisAlert', object.cpIsAlertPresent],
      ['occupation', object.occupation],
      ['majorTraumaFlag', object.majorTraumaFlag],
      ['the111flag', object.flag111],
      ['the111flagDate', object.flag111Timestamp?.toISOString()],
      ["households", RequestDataParser.mapHouseholdObject(object)],
      ["escorts", RequestDataParser.mapEscortObject(object)],
      ['mergeRequest', getMergePatientObject(object)],
      ["employerName", object.employerName],
      ["employerAddress", object.employerAddress ? {
        addressLines: [object.employerAddress],
        postalCode: object.employerPostalCode,
      } : null],
      ['attendanceId', object.lastAttendanceId],
      ['attendanceCategory', object.attendanceCategory],
      ['patientFlags', handleRefreshPatientFlags(object)],
      ['attendanceAssaultRelated', object?.assaultRelated],
      ['feedback', object?.feedback],
    ]);

    const modeValues = {
      'temporaryFastAttendance': ['historyOfPresentingComplaint', 'chiefComplaintCode', 'admitDate', 'arrivalModeCode', 'ambulanceIncidentNumber', 'conveyingAmbulanceOrgId', 'careContactIdentifier'],
      // 'updateTemporaryPatient': ['admitDate', 'historyOfPresentingComplaint', 'chiefComplaintCode', 'arrivalModeCode', 'ehicNotProvidedReason', 'ambulanceIncidentNumber', 'cpis', 'cpisAlert', 'occupation', 'households', 'escorts', 'employerName', 'employerAddress', 'mergeRequest', 'conveyingAmbulanceOrgId', 'careContactIdentifier'],
      'updateTemporaryPatient': ['mergeRequest', 'chiefComplaintCode','historyOfPresentingComplaint', 'ehicNotProvidedReason', 'admitDate', 'arrivalModeCode', 'attendanceSourceCode', 'locationCode', 'attendanceTypeCode', 'ambulanceIncidentNumber', 'conveyingAmbulanceOrgId', 'careContactIdentifier', 'cpis', 'cpisAlert', 'occupation', 'majorTraumaFlag', 'the111flag', 'the111flagDate', 'households', 'escorts', 'employerName', 'employerAddress', 'attendanceId', 'attendanceCategory', 'patientFlags', 'attendanceAssaultRelated'],
      'createOnlyPatient': ['ehicNotProvidedReason', 'ambulanceIncidentNumber', 'cpis', 'cpisAlert', 'occupation', 'households', 'escorts', 'employerName', 'employerAddress', 'mergeRequest', 'conveyingAmbulanceOrgId', 'careContactIdentifier'],
      "updatePatient": ['cpis', 'cpisAlert', 'ehicNotProvidedReason', 'occupation', 'households', 'escorts', 'employerName', 'employerAddress' ],
      'createAttendance': ['historyOfPresentingComplaint', 'chiefComplaintCode', 'ehicNotProvidedReason', 'admitDate', 'arrivalModeCode', 'attendanceSourceCode', 'locationCode', 'attendanceTypeCode', 'ambulanceIncidentNumber', 'cpis', 'cpisAlert', 'occupation', 'majorTraumaFlag', 'the111flag', 'the111flagDate', 'households', 'escorts', 'employerName', 'employerAddress', 'conveyingAmbulanceOrgId', 'careContactIdentifier', 'attendanceCategory', 'attendanceAssaultRelated', 'feedback'],
      // "updateAttendance": ['attendanceId', 'admitDate', 'historyOfPresentingComplaint', 'chiefComplaintCode', 'ehicNotProvidedReason', 'arrivalModeCode', 'attendanceSourceCode', 'locationCode', 'attendanceTypeCode', 'ambulanceIncidentNumber', 'cpis', 'cpisAlert', 'occupation', 'majorTraumaFlag', 'the111flag', 'the111flagDate', 'households', 'escorts', 'employerName', 'employerAddress', 'conveyingAmbulanceOrgId', 'careContactIdentifier'],
      'updateAttendance' : ['chiefComplaintCode','historyOfPresentingComplaint', 'ehicNotProvidedReason', 'admitDate', 'arrivalModeCode', 'attendanceSourceCode', 'locationCode', 'attendanceTypeCode', 'ambulanceIncidentNumber', 'conveyingAmbulanceOrgId', 'careContactIdentifier', 'cpis', 'cpisAlert', 'occupation', 'majorTraumaFlag', 'the111flag', 'the111flagDate', 'households', 'escorts', 'employerName', 'employerAddress', 'attendanceId', 'attendanceCategory', 'patientFlags', 'attendanceAssaultRelated', 'feedback']
    }

    let valueToReturn = {};

    modeValues[mode].forEach((key) => {
      const value = attendanceMap.get(key);
      if (value) {
        valueToReturn[key] = value;
      }
    })

    return valueToReturn;
  }

  const getRequestDemographicsData = useCallback((admitObj, patientUpdate = false) => {
    let admitTmp;

    if (admitObj.hospitalNumber && !patientUpdate) {
      admitTmp = {
        patientUpdate: false,
        patient: {
          ...handleGetPatientValue(admitObj, "selectPatient")
        }
      }
    }

    if (patientUpdate || !admitObj.hospitalNumber ||
        (admitObj.hospitalNumber && isTemporaryPatientEdit)
    ) {
      admitTmp = {
        ...admitTmp,
        patient: {
          ...handleGetPatientValue(admitObj, "createPatient")
        }
      };

      if (admitObj.ehicCard !== null) {
        switch (admitObj.ehicCard) {
          case true:
            admitTmp = {
              ...admitTmp,
              patient: {
                ...admitTmp.patient,
                patientNumbers: [
                  {
                    number: admitObj.ehicNumber,
                    type: "EhicNumber",
                    simpleType: null,
                    incomingSystem: null,
                  },
                ],
              },
            };
            break;
          case false:
            admitTmp = {
              ...admitTmp,
              ehicNotProvidedReason: admitObj.noEhicReason,
            };
            break;
          default:
            break;
        }
      }

    if (patientUpdate) {
      admitTmp = {
        // ...admitTmp,
        patientUpdate: true,
        patient: {
          ...admitTmp.patient,
          ...handleGetPatientValue(admitObj, "updatePatient"),
        },
        ...handleGetAttendanceValue(admitObj, 'updatePatient')
      };
    }
      if (admitTmp?.cpis && _.isNil(admitTmp?.cpisAlert)) {
        admitTmp.cpisAlert = false;
      }
      if (!admitTmp?.cpis && !_.isNil(admitTmp?.cpisAlert)) {
        delete admitTmp.cpisAlert;
      }
    }
    if (hospital?.hospitalId) {
      admitTmp = {
        ...admitTmp,
        odsCode: hospital?.hospitalId,
      }
    }
    return admitTmp;
  }, [isTemporaryPatientEdit, hospital]);

  const handleAbortBedas = (pt) => {
    let wardIds = [];
    if (config.modules?.map?.customMap) wardIds.push(`ED##${newCurrentMap?.hospitalId}`);
    else wardIds = ["ED", "0EDAU"];

    API.findPatientsInWard({wardIds, bedasStatus: "started"})
        .then(res => {
          if (res?.data?.__data) {
            const findPt = _.find(res?.data?.__data, p => p?.patient?.__id === pt?.hospitalNumber);
            if (findPt) API.updatePatientInWard(findPt?.__id, [{"bedas.status": "canceledOtherAdmit"}]).then(() => console.log("FLAG REMOVE"))
          }
        });
  };

  const getValidSdecObject = (sdec) => {
    let validObj = {...sdec};
    delete validObj._id;
    delete validObj.description;
    return validObj;
  }

  const addAdmit = async (admitObj) => {
    let admitTmp;

    // PATIENT DATA
    if (!fastRegFlag && !speedRegFlag) {
      admitTmp = getRequestDemographicsData(admitObj)

      // ATTENDANCE DATA
      if (!isBedBookingChosen) {
        admitTmp = {
          ...admitTmp,
          ...handleGetAttendanceValue(admitObj, "createAttendance")
        }
      }

      if (isBedBookingChosen) {
        admitTmp = {
          patient: {
            ...admitTmp.patient,
          },
        };

        admitTmp = {
          ...admitTmp,
          csmContactedTime: bedBookingForm
        };

        if (admitObj.specialty) {
          admitTmp = {
            ...admitTmp,
            specialty: admitObj.specialty,
          };
        }

        if (admitObj.triage) {
          admitTmp = {
            ...admitTmp,
            triage: admitObj.triage,
          };
        }

        if (admitObj.alarms) {
          if (!_.isEmpty(admitObj.alarms[0])) {
            admitTmp = {
              ...admitTmp,
              alarms: admitObj.alarms,
            };
          }
        }

        if (admitObj.currentSiteBedBooking) {
          admitTmp = {
            ...admitTmp,
            currentSiteBedBooking: admitObj.currentSiteBedBooking,
          };
        }

        if (admitObj.sdecSite) {
          admitTmp = {
            ...admitTmp,
            sdecSite: getValidSdecObject(admitObj.sdecSite),
          };
        }
      }
    }

    if (fastRegFlag || speedRegFlag) {
      let tag = fastRegFlag ? "fastRegistry" : "temporary";
      admitTmp = {
        speedRegistry: speedRegFlag || admitObj.speedRegistry,
        patient: {
          tags: [tag],
          ...handleGetPatientValue(admitObj, 'temporaryFastAttendance'),
        },
        ...handleGetAttendanceValue(admitObj, "temporaryFastAttendance")
      };
    }

    if (!fastRegFlag && !speedRegFlag && admitObj.patientUnknown) {
      const tag = _.isEmpty(admitTmp?.patient?.tags) ? ['unknown'] : [...admitTmp.patient.tags, 'unknown'];
      admitTmp['patient']['tags'] = tag;
    }

    // Update attendance flag if patient is on whiteboard
    if (patientOnWhiteboard && admitTmp.admitDate) {
      admitTmp = {
        ...admitTmp,
        patient: {
          ...handleGetPatientValue(admitObj, 'updateAttendance')
        },
        ...handleGetAttendanceValue(admitObj, 'updateAttendance'),
        attendanceUpdate: true,
      }
    }

    if (isAddOnlyPatient) {
      admitTmp = {
        patient: {
          ...handleGetPatientValue(admitObj, 'createPatient')
        },
        ...handleGetAttendanceValue(admitObj, 'createOnlyPatient')
      }
    }

    if (temporaryPatientRef.current) {
      admitTmp = {
        ...handleGetAttendanceValue(admitObj, 'updateTemporaryPatient'),
        patient: {
          ...handleGetPatientValue(admitObj, 'updateTemporaryPatient')
        },
      }
    }

    if (temporaryPatientAttendanceRef.current) {
      admitTmp = {
        ...admitTmp,
        patient: {
          ...admitTmp.patient,
          ...handleGetPatientValue(admitObj, 'updateAttendance')
        },
        ...handleGetAttendanceValue(admitObj, 'updateAttendance'),
        attendanceUpdate: true
      };
    }

    if (config.modules?.map?.customMap && hospital?.hospitalId) {
      admitTmp = {
        ...admitTmp,
        facility: hospital?.hospitalId,
        odsCode: hospital?.hospitalId,
      };
    } else if (config.modules?.wardCreator?.admitModeEnable && hospital?.__id) {
      admitTmp = {
        ...admitTmp,
        facility: hospital?.__id,
        odsCode: hospital?.__id,
      };
    } else if (!config.modules?.map?.customMap) {
      admitTmp = {
        ...admitTmp,
        facility: config?.modules?.wardCreator?.defaultHospitalId || 'RBD01',
        odsCode: config?.modules?.wardCreator?.defaultHospitalId || 'RBD01',
      };
    }

    if (admitTmp?.cpis && _.isNil(admitTmp?.cpisAlert)) {
      admitTmp.cpisAlert = false;
    }
    if (!admitTmp?.cpis && !_.isNil(admitTmp?.cpisAlert)) {
      delete admitTmp.cpisAlert;
    }

    const abortedBedas = (!isBedas && !temporaryPatientRef.current) && (admit && admit.tags && admit.tags.includes("bedas"));
    try {
      dispatch(setLoadingGlobal(true));

      if ((isReAttendance || (abortedBedas || bedasRemove)) && admit) {
        let tags = admit.tags ? _.cloneDeep(admit.tags) : [];
        if (isReAttendance && !tags.includes("reAttendance")) tags.push("reAttendance");
        if ((abortedBedas || bedasRemove) && tags.includes("bedas")) tags = _.filter(tags, tag => tag !== "bedas");
        await API.updatePatientTags(admit.hospitalNumber, tags).then(e => console.log("Flag saved"));
      }

      if (abortedBedas || bedasRemove) handleAbortBedas(admit)

      if (isBedBookingChosen) {
        if (admitTmp?.odsCode) {
          delete admitTmp?.odsCode;
        }

        await API.admitWithBedBooking(admitTmp, controller.signal).then(() => {
          setActiveStep(0);
          renderSuccessSnackbar("Patient successfully added to bed booking.");
        });
      } else if (temporaryPatientRef.current) {
        const asArray = Object.entries(admitTmp.patient);
        const filtered = asArray.filter(([key, value]) => key !== "hospitalNumber" && key !== '__id');
        if(admitTmp?.patient?.tags && admitTmp?.patient?.tags?.includes('temporary')) {
          admitTmp.patient.tags = _.filter(admitTmp?.patient?.tags, tag => tag !== "temporary");
        }

        const admitObjectMerge = {
          ...admitTmp,
          patient: {
            ...Object.fromEntries(filtered)
          }
        }
        if (hospital?.hospitalId) {
          admitTmp = {
            ...admitTmp,
            odsCode: hospital?.hospitalId,
          }
        }

        if (bedasRemove) {
          let tags = admitTmp?.patient?.tags ? _.cloneDeep(admitTmp.patient.tags) : [];
          tags = _.filter(tags, tag => tag !== 'bedas');
          admitTmp.patient.tags = tags;
        }

        await API.admitWithMerge(admitTmp, controller.signal).then(() => {
          setActiveStep(0);
          renderSuccessSnackbar("Patient merge has been registered. Changes will be visible within a few minutes.");
        });
      } else {
        if (hospital?.hospitalId) {
          admitTmp = {
            ...admitTmp,
            odsCode: hospital?.hospitalId,
          }
        }
        await API.patientAdmission(admitTmp, controller.signal).then(() => {
          isAddOnlyPatient ?
              renderSuccessSnackbar("Patient has been successfully created.") :
              renderSuccessSnackbar(`Attendance has been successfully ${admitTmp.attendanceUpdate ? "updated" : "created"}.`);
          setActiveStep(0);
        })
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        renderNoPermissionSnackbar();
        return;
      }
      console.error(error);
      renderErrorSnackbar("An error occured. Please try again later.")
    } finally {
      dispatch(setLoadingGlobal(false))
    }
  };

  const handleUpdatePatient = useCallback(async (admitObj) => {
    const admitData = getRequestDemographicsData(admitObj, true)
    try {
      dispatch(setLoadingGlobal(true))

      await API.patientAdmission(admitData, controller.signal).then(() => {
        renderSuccessSnackbar("Patient data has been successfully updated.");
        setIsPatientUpdated(false);
      })
    } catch (error) {
      if (error?.response?.status === 403) {
        renderNoPermissionSnackbar();
        return;
      }

      renderErrorSnackbar("An error occured. Please try again later.");
      } finally {
        dispatch(setLoadingGlobal(false));
      }
  }, [hospital])


  const handleSubmitAdmission = () =>
    addAdmit({ ...admit, ...admission, ...bedBookingData });

  const isCompleted = () => {
    const isCustomMap = config.modules?.map?.customMap
      ? !_.isNil(hospital)
      : true;

    const basicRequiredFields = [
      "firstName",
      "familyName",
      "dob",
      "postalCode",
      "addressLines",
      "gender",
    ];
    const additionalRequiredFields =
      config.admitPatient?.additionalRequiredPatientFields;

    const basicRequiredFieldsValid = basicRequiredFields.every((field) => {
      if (field === "dob") {
        return admit[field]?._isValid;
      }
      return admit[field];
    });
    const additionalRequiredFieldsValid = additionalRequiredFields?.every(
      (field) => {
        return admit[field];
      }
    );

    return (
      isCustomMap &&
      (patientIsSelected ||
        (basicRequiredFieldsValid && additionalRequiredFieldsValid))
    );
  };

  const handleBackToSearch = (step) => {
    setActiveStep(step);
    if (ptFormPriority && step === 0) dispatch(setDemographicPatient(null));
  }

  const renderSummary = () => {
    return (
        <Summary
            admit={admit}
            addAdmit={addAdmit}
            admission={admission}
            bedBooking={bedBookingData}
            isBedBookingChosen={isBedBookingChosen}
            bedBookingForm={bedBookingForm}
            temporaryPatientRef={temporaryPatientRef}
            isAddOnlyPatient={isAddOnlyPatient}
        />
    )
  }

  const renderAttendanceErrorMessage = () => {
    return (
        <>
          <InformationBox type="warning">
            {t("There was a problem with downloading attendance data for a temporary patient.")}
          </InformationBox>
        </>
    )
  }

  const handleCloseAttendanceError = (_e, reason) => {
    if (reason !== 'backdropClick') {
      tempPt.current = null;
      closeAttErrorDownload();
      setActiveStep(0);
    }
  };

  const handleRecallAttendance = () => {
    if (tempPt.current) {
      closeAttErrorDownload();
      getLastAttendance(tempPt.current);
      tempPt.current = null;
    }
  };

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return renderPatientSearch()
      case 1:
        return (
          <DemographicDetails
            patientIsSelected={patientIsSelected}
            addAdmit={addAdmit}
            admit={admit}
            setAdmit={setAdmit}
            admission={admission}
            setAdmission={setAdmission}
            setPatientIsSelected={setPatientIsSelected}
            isCompleted={isCompleted}
            setActiveStep={handleBackToSearch}
            patientUnknown={patientUnknown}
            setPatientUnknown={setPatientUnknown}
            isPatientUpdated={isPatientUpdated}
            setIsPatientUpdated={setIsPatientUpdated}
            patientOnWhiteboard={patientOnWhiteboard}
            isGenderMandatoryDialogOpen={isGenderMandatoryDialogOpen}
            openGenderMandatoryDialog={openGenderMandatoryDialog}
            closeGenderMandatoryDialog={closeGenderMandatoryDialog}
            speedRegFlag={speedRegFlag}
            setSpeedRegFlag={setSpeedRegFlag}
            fastReg={fastRegFlag}
            arrivalModeOptions={arrivalModeOptions}
            isArrivalModeOptionsLoading={isArrivalModeOptionsLoading}
            chiefComplaintOptions={chiefComplaintOptions}
            isChiefComplaintOptionsLoading={isChiefComplaintOptionsLoading}
            isTemporaryPatientEdit={isTemporaryPatientEdit}
            temporaryPatientRef={temporaryPatientRef}
            temporaryPatientAttendanceRef={temporaryPatientAttendanceRef}
            isAddOnlyPatient={isAddOnlyPatient}
            mergeToNewCreatedPatient={mergeToNewCreatedPatient}
            conveyingAmbulanceOptions={conveyingAmbulanceOptions}
            conveyingAmbulanceLoading={conveyingAmbulanceLoading}
            renderSuccessSnackbar={renderSuccessSnackbar}
            renderInfoSnackbar={renderInfoSnackbar}
            renderErrorSnackbar={renderErrorSnackbar}
            checkFields={checkFields}
            setSearchValue={setSearchValue}
            searchPatients={searchPatients}
            nhsNumberValid={nhsNumberValid}
            validPostCode={validPostCode}
            setValidPostCode={setValidPostCode}
            validTemporaryPostCode={validTemporaryPostCode}
            setValidTemporaryPostCode={setValidTemporaryPostCode}
            toggleNFA={toggleNFA}
            setToggleNFA={setToggleNFA}
            toggleNFATemporary={toggleNFATemporary}
            setToggleNFATemporary={setToggleNFATemporary}
          />
        );
      case 2:
        if (isAddOnlyPatient) {
            return renderSummary()
          } else if (isBedBookingChosen) {
            return (
                <BedBookingAdmit
                    bedBookingForm={bedBookingData}
                    form={bedBookingForm}
                    setForm={setBedBookingForm}
                    modifyValues={(val) => modifyValue(val)}
                    isAlarmOpen={isAlarmOpen}
                    openAlarmDialog={openAlarmDialog}
                    closeAlarmDialog={closeAlarmDialog}
                    bedBookingFormRef={bedBookingFormRef}
                    hospital={hospital}
                />
            );
          } else {
            return (
                <AdmissionDetails
                    admit={admit}
                    setAdmit={setAdmit}
                    addAdmit={addAdmit}
                    isCompleted={isCompleted}
                    setActiveStep={setActiveStep}
                    admission={admission}
                    setAdmission={setAdmission}
                    patientAge={patientAge}
                    patientOnWhiteboard={patientOnWhiteboard}
                    continueAttendanceRef={continueAttendanceRef}
                    arrivalModeOptions={arrivalModeOptions}
                    isArrivalModeOptionsLoading={isArrivalModeOptionsLoading}
                    chiefComplaintOptions={chiefComplaintOptions}
                    isChiefComplaintOptionsLoading={isChiefComplaintOptionsLoading}
                    attendanceSourceOptions={attendanceSourceOptions}
                    isAttendanceSourceOptionsLoading={isAttendanceSourceOptionsLoading}
                    attendanceTypeOptions={attendanceTypeOptions}
                    isAttendanceTypeOptionsLoading={isAttendanceTypeOptionsLoading}
                    locationOptions={locationOptions}
                    attendanceCategoryOptions={attendanceCategoryOptions}
                    isLocationOptionsLoading={isLocationOptionsLoading}
                    conveyingAmbulanceOptions={conveyingAmbulanceOptions}
                    conveyingAmbulanceLoading={conveyingAmbulanceLoading}
                    isBedas={isBedas}
                    tempPatient={temporaryPatientRef.current}
                    bedasRemove={bedasRemove}
                />
            );
          }
      case 3:
        return renderSummary();
      default: {
        return null;
      }
    }
  };

  const handleChangeHospital = (_e, val) => {
    setHospital(val);
    dispatch(updateMap(val));
  };

  const onHeaderBackClick = () => {
    return isCentralPageModuleEnabled ? history.goBack() : history.push("/");
  };

  const patientInfo = new Map([
    ["Born:", admit?.dob?.format("DD/MM/YYYY")],
    ["Age:", patientAge],
    ["Gender:", admit?.gender?.__description],
    ["Hos No:", admit?.hospitalNumber],
    ["NHS No:", admit?.nhsNumber],
  ]);

  const renderHeaderPatientDemographics = () => {
    return (
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12} sm={6} md={3} sx={{ ml: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {patientIsSelected
              ? `${admit.familyName}, ${admit.firstName}`
              : t("Create New Attendance")}
          </Typography>
        </Grid>
        {patientIsSelected && (
          <Grid
            item
            xs={12}
            sm={6}
            md={7}
            className={classes.headerDemographics}
          >
            {Array.from(patientInfo).map(
              ([key, value]) =>
                (value || _.isNumber(value)) && (
                  <Fragment key={key}>
                    <Typography
                      variant="body1"
                      textAlign="center"
                      sx={{ display: "inline-block", marginRight: "2px" }}
                      key={key+value}
                    >
                      {key}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      textAlign="center"
                      key={value+key}
                      sx={{
                        fontWeight: "bold",
                        display: "inline-block",
                        marginRight: "15px",
                      }}
                    >
                      {value}
                    </Typography>
                  </Fragment>
                )
            )}
          </Grid>
        )}
      </Grid>
    );
  };

  const bedasListButtons = () => {
    let buttons = [];
    if (config?.bedasSessionManagementEnabled) {
      buttons.push(
          <AgyleButton
              onClick={() => bedasCalendar.current?.openSessionList()}
              variant="contained"
              color="primary"
          >
            {t("Open Session List")}
          </AgyleButton>)
    }

    buttons.push(
        <AgyleButton
            onClick={() => bedasCalendar.current?.openCalendar()}
            variant="contained"
            color="primary"
        >
          {t("Open Calendar")}
        </AgyleButton>
    )

    return buttons;
  }

  return (
    config.admitPatient.registration && (
      <>
        <Grid
          container
          direction="row"
          style={{ position: "sticky", top: 0, zIndex: 10 }}
          className={classes.stickyHeader}
        >
          <AgyleHeader borderBottom onBack={onHeaderBackClick}>
            {renderHeaderPatientDemographics()}
          </AgyleHeader>

          <AgyleButtonSection
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            steps={activeSteps}
            admit={admit}
            admission={admission}
            checkFields={checkFields}
            patientIsSelected={patientIsSelected}
            setClearForm={setClearForm}
            updatePatient={updatePatient}
            cancelPatientUpdate={cancelPatientUpdate}
            savePatientUpdate={savePatientUpdate}
            backToInitialAdmit={backToInitialAdmit}
            isPatientUpdated={isPatientUpdated}
            handleSubmitAdmission={handleSubmitAdmission}
            patientOnWhiteboard={patientOnWhiteboard}
            openCreatePatientDialog={openCreatePatientDialog}
            isBedBookingChosen={isBedBookingChosen}
            setSpeedRegFlag={handleProceedToSpeedReg}
            openTemporaryPatientEdit={openTemporaryPatientEdit}
            fastReg={fastRegFlag}
            createNewPatient={createNewPatient}
            handleUpdatePatient={handleUpdatePatient}
            handleConfirmDemographics={openConfirmDemographics}
            openBedas={openBedas}
            openPriorityList={openPriorityList}
            openPatientMerge={openPatientMerge}
            hospital={hospital}
            temporaryPatientRef={temporaryPatientRef}
            temporaryPatientAttendanceRef={temporaryPatientAttendanceRef}
            isAddOnlyPatient={isAddOnlyPatient}
            onlyDemographic={onlyDemographic}
            validPostCode={validPostCode || toggleNFA}
            validTemporaryPostCode={validTemporaryPostCode || toggleNFATemporary}
          />
        </Grid>

        <div className={classes.body}>
          {config.modules?.map?.customMap && activeStep === 0 && (
            <Grid item xs={12} style={{ marginBottom: 10 }}>
              <Autocomplete
                name="Hospital"
                renderInput={(params) => (
                  <TextField error={!hospital} {...params} label="Hospital" />
                )}
                getOptionLabel={(option) => option.name}
                options={config.modules?.map?.customMapConfig}
                value={hospital}
                isOptionEqualToValue={(option, value) =>
                  option.hospitalId === value.hospitalId
                }
                onChange={handleChangeHospital}
                disabled={!_.isNil(hospital)}
              />
            </Grid>
          )}

          {config.modules?.wardCreator?.admitModeEnable && !config.modules?.map?.customMap && activeStep === 0 &&
            <Grid item xs={12} style={{ marginBottom: 10 }}>
              <Autocomplete
                name="Hospital"
                renderInput={(params) => (
                  <TextField error={!hospital} {...params} label="Hospital" />
                )}
                getOptionLabel={(option) => option.description}
                options={hospitalList}
                value={hospital}
                isOptionEqualToValue={(option, value) =>
                  option.__id === value.__id
                }
                onChange={handleChangeHospital}
                disabled={!_.isNil(hospital)}
              />
            </Grid>
          }

          <Stepper activeStep={activeStep} alternativeLabel nonLinear>
            {activeSteps.map((step, index) => (
              <Step key={step.id}>
                <StepButton
                  color="inherit"
                  style={{
                    cursor: 'auto'
                  }}
                  disabled={activeStep > 0 && !checkFields()}
                  disableRipple
                >
                  {step.label}
                </StepButton>
              </Step>
            ))}
          </Stepper>

          {renderStep()}
        </div>

        <MessageBox
            title={t("Confirmation")}
            haveAccept={{yes: t("Yes"), no: t("No")}}
            warning
            onAccept={handleConfirmDemographics}
            onClose={closeConfirmDemographics}
            message={t("Are you sure you want to confirm the patient's demographics?")}
            open={isConfirmDemographicsOpen}
        />

        {(config?.admitPatient?.enablePriorityList && dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_PRIORTY_LIST))) &&
          <PriorityListModal
              open={isPriorityListOpen}
              onClose={closePriorityList}
              hospital={hospital}
              fromAdmit
          />
        }

        {(config?.admitPatient?.bedasListEnabled && config?.modules?.bedas?.enabled) &&
            <AgyleDialog
                title={t('Follow Up')}
                open={isBedasOpen}
                onClose={closeBedas}
                fullWidth
                disableSave
                width="lg"
                buttons={bedasListButtons()}
            >
              <BedasList ref={bedasCalendar} editDisabled={!canEditBedasSessions} hospital={newCurrentMap}/>
            </AgyleDialog>
        }

        {(config?.admitPatient?.enablePatientMerge && dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_MERGES_PAGE, Permissions.CAN_ACCESS_ADMIN_PAGE]))) &&
            <AgyleDialog
                title={t("Patient Merge")}
                open={isPatientMergeOpen}
                width="lg"
                fullWidth
                onClose={closePatientMerge}
                disableSave
            >
              <PatientMerges/>
            </AgyleDialog>
        }

        <MessageBox
            open={isAttErrorDownloadOpen}
            title={t("Warning")}
            haveAccept={{yes: t("Try Again"), no: t("Return to search")}}
            onAccept={handleRecallAttendance}
            onClose={handleCloseAttendanceError}
            messageObject={renderAttendanceErrorMessage()}
        />
      </>
    )
  );
}

export default memo(AdmitPatient);
